export const CERTIFICATIONS = [
  // ============================================================
  // ARCHITECTURE, BIM & CONSTRUCTION
  // ============================================================

  {
    id: "autodesk-revit-architectural",
    name: "Autodesk Certified Professional: Revit for Architectural Design",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Revit skills for architectural design and BIM workflows.",
    skills: ["Revit", "BIM", "Architectural Design"],
    careerPaths: ["BIM Engineer", "BIM Modeler", "Architectural Designer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-revit-structural",
    name: "Autodesk Certified Professional: Revit for Structural Design",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Revit skills for structural modeling and documentation.",
    skills: ["Revit", "Structural BIM", "Structural Design"],
    careerPaths: ["Structural BIM Engineer", "BIM Modeler", "Structural Designer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-revit-mep",
    name: "Autodesk Certified Professional: Revit MEP",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Revit skills for mechanical, electrical and plumbing BIM workflows.",
    skills: ["Revit", "MEP", "BIM"],
    careerPaths: ["MEP BIM Engineer", "MEP Coordinator", "BIM Modeler"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-revit-mechanical",
    name: "Autodesk Certified Professional: Revit for Mechanical Design",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Revit skills for mechanical MEP design workflows.",
    skills: ["Revit MEP", "Mechanical Design", "BIM"],
    careerPaths: ["Mechanical BIM Engineer", "Mechanical BIM Modeler", "MEP Designer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-revit-electrical",
    name: "Autodesk Certified Professional: Revit for Electrical Design",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Revit skills for electrical BIM workflows.",
    skills: ["Revit MEP", "Electrical Design", "BIM"],
    careerPaths: ["Electrical BIM Engineer", "ELV BIM Engineer", "Electrical BIM Modeler"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-autocad",
    name: "Autodesk Certified Professional: AutoCAD for Design and Drafting",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates advanced AutoCAD skills for professional design and drafting.",
    skills: ["AutoCAD", "CAD", "Technical Drawing"],
    careerPaths: ["CAD Engineer", "CAD Draftsman", "Design Engineer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-civil3d",
    name: "Autodesk Certified Professional: Civil 3D",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates professional Civil 3D skills for civil infrastructure workflows.",
    skills: ["Civil 3D", "Infrastructure", "Civil Engineering"],
    careerPaths: ["Civil BIM Engineer", "Civil Designer", "Infrastructure Engineer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-navisworks",
    name: "Autodesk Certified Professional: Navisworks",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates model coordination, review and clash-detection skills.",
    skills: ["Navisworks", "BIM Coordination", "Clash Detection"],
    careerPaths: ["BIM Coordinator", "BIM Engineer", "VDC Engineer"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "buildingSMART-professional",
    name: "buildingSMART Professional Certification",
    provider: "buildingSMART",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Validates knowledge of open BIM concepts and information management.",
    skills: ["OpenBIM", "IFC", "BIM"],
    careerPaths: ["BIM Manager", "BIM Coordinator", "BIM Consultant"],
    officialUrl: "https://www.buildingsmart.org/"
  },
  {
    id: "leed-green-associate",
    name: "LEED Green Associate",
    provider: "USGBC",
    category: "Architecture, BIM & Construction",
    level: "Associate",
    description: "Foundational credential covering green building and sustainable design principles.",
    skills: ["LEED", "Green Building", "Sustainability"],
    careerPaths: ["Sustainability Consultant", "Architect", "BIM Engineer"],
    officialUrl: "https://www.usgbc.org/credentials"
  },
  {
    id: "leed-ap-bdc",
    name: "LEED AP Building Design + Construction",
    provider: "USGBC",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Advanced credential for sustainable building design and construction.",
    skills: ["LEED", "Sustainable Design", "Construction"],
    careerPaths: ["Sustainability Consultant", "Architect", "Construction Manager"],
    officialUrl: "https://www.usgbc.org/credentials"
  },
  {
    id: "pmi-construction",
    name: "PMI Construction Professional",
    provider: "PMI",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Professional project-management credential focused on construction.",
    skills: ["Construction Management", "Project Management", "Planning"],
    careerPaths: ["Construction Manager", "Project Manager", "Construction Planner"],
    officialUrl: "https://www.pmi.org/certifications"
  },
  {
    id: "rics-chartered-surveyor",
    name: "RICS Chartered Surveyor",
    provider: "RICS",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Professional qualification for surveying and property-related careers.",
    skills: ["Surveying", "Property", "Construction"],
    careerPaths: ["Quantity Surveyor", "Building Surveyor", "Property Surveyor"],
    officialUrl: "https://www.rics.org/"
  },
  {
    id: "aace-cost-professional",
    name: "AACE Certified Cost Professional",
    provider: "AACE International",
    category: "Architecture, BIM & Construction",
    level: "Professional",
    description: "Professional credential for cost engineering and project controls.",
    skills: ["Cost Engineering", "Estimating", "Project Controls"],
    careerPaths: ["Cost Engineer", "Quantity Surveyor", "Project Controls Engineer"],
    officialUrl: "https://web.aacei.org/certification"
  },

  // ============================================================
  // ENGINEERING
  // ============================================================

  {
    id: "asq-quality-engineer",
    name: "ASQ Certified Quality Engineer",
    provider: "ASQ",
    category: "Engineering",
    level: "Professional",
    description: "Professional credential covering quality engineering methods.",
    skills: ["Quality Engineering", "Statistics", "Process Improvement"],
    careerPaths: ["Quality Engineer", "Process Engineer", "Quality Manager"],
    officialUrl: "https://www.asq.org/cert"
  },
  {
    id: "asq-quality-auditor",
    name: "ASQ Certified Quality Auditor",
    provider: "ASQ",
    category: "Engineering",
    level: "Professional",
    description: "Validates professional auditing and quality-system skills.",
    skills: ["Quality Auditing", "ISO", "Quality Systems"],
    careerPaths: ["Quality Auditor", "Quality Engineer", "Compliance Specialist"],
    officialUrl: "https://www.asq.org/cert"
  },
  {
    id: "asq-reliability-engineer",
    name: "ASQ Certified Reliability Engineer",
    provider: "ASQ",
    category: "Engineering",
    level: "Professional",
    description: "Validates reliability engineering and risk-management skills.",
    skills: ["Reliability", "Risk", "Statistics"],
    careerPaths: ["Reliability Engineer", "Quality Engineer", "Maintenance Engineer"],
    officialUrl: "https://www.asq.org/cert"
  },
  {
    id: "asq-six-sigma-green-belt",
    name: "ASQ Certified Six Sigma Green Belt",
    provider: "ASQ",
    category: "Engineering",
    level: "Professional",
    description: "Validates applied Six Sigma process-improvement skills.",
    skills: ["Six Sigma", "DMAIC", "Process Improvement"],
    careerPaths: ["Process Engineer", "Continuous Improvement Engineer", "Quality Engineer"],
    officialUrl: "https://www.asq.org/cert"
  },
  {
    id: "asq-six-sigma-black-belt",
    name: "ASQ Certified Six Sigma Black Belt",
    provider: "ASQ",
    category: "Engineering",
    level: "Professional",
    description: "Advanced Six Sigma credential for complex improvement projects.",
    skills: ["Six Sigma", "DMAIC", "Leadership"],
    careerPaths: ["Process Improvement Manager", "Quality Manager", "Continuous Improvement Lead"],
    officialUrl: "https://www.asq.org/cert"
  },
  {
    id: "ncees-fe-civil",
    name: "NCEES FE Civil",
    provider: "NCEES",
    category: "Engineering",
    level: "Foundation",
    description: "Engineering fundamentals exam pathway for civil engineering.",
    skills: ["Civil Engineering", "Engineering Fundamentals", "Design"],
    careerPaths: ["Civil Engineer", "Civil Designer", "Graduate Engineer"],
    officialUrl: "https://ncees.org/exams/exam-prep-materials/exam-prep-materials-fe-exams/"
  },
  {
    id: "ncees-fe-mechanical",
    name: "NCEES FE Mechanical",
    provider: "NCEES",
    category: "Engineering",
    level: "Foundation",
    description: "Engineering fundamentals exam pathway for mechanical engineering.",
    skills: ["Mechanical Engineering", "Engineering Fundamentals", "Design"],
    careerPaths: ["Mechanical Engineer", "Design Engineer", "Graduate Engineer"],
    officialUrl: "https://ncees.org/exams/exam-prep-materials/exam-prep-materials-fe-exams/"
  },
  {
    id: "ncees-fe-electrical",
    name: "NCEES FE Electrical and Computer",
    provider: "NCEES",
    category: "Engineering",
    level: "Foundation",
    description: "Engineering fundamentals exam pathway for electrical and computer engineering.",
    skills: ["Electrical Engineering", "Electronics", "Computer Engineering"],
    careerPaths: ["Electrical Engineer", "Electronics Engineer", "Computer Engineer"],
    officialUrl: "https://ncees.org/exams/exam-prep-materials/exam-prep-materials-fe-exams/"
  },
  {
    id: "ncees-pe-civil",
    name: "NCEES PE Civil",
    provider: "NCEES",
    category: "Engineering",
    level: "Professional",
    description: "Professional engineering exam pathway for civil engineering.",
    skills: ["Civil Engineering", "Professional Engineering", "Design"],
    careerPaths: ["Civil Engineer", "Structural Engineer", "Infrastructure Engineer"],
    officialUrl: "https://ncees.org/exams/"
  },
  {
    id: "ncees-pe-mechanical",
    name: "NCEES PE Mechanical",
    provider: "NCEES",
    category: "Engineering",
    level: "Professional",
    description: "Professional engineering exam pathway for mechanical engineering.",
    skills: ["Mechanical Engineering", "Professional Engineering", "Design"],
    careerPaths: ["Mechanical Engineer", "HVAC Engineer", "Design Engineer"],
    officialUrl: "https://ncees.org/exams/"
  },
  {
    id: "ncees-pe-electrical",
    name: "NCEES PE Electrical and Computer",
    provider: "NCEES",
    category: "Engineering",
    level: "Professional",
    description: "Professional engineering exam pathway for electrical and computer engineering.",
    skills: ["Electrical Engineering", "Power", "Electronics"],
    careerPaths: ["Electrical Engineer", "Power Engineer", "Electronics Engineer"],
    officialUrl: "https://ncees.org/exams/"
  },
  {
    id: "nace-cip-level-1",
    name: "NACE CIP Level 1",
    provider: "AMPP",
    category: "Engineering",
    level: "Foundation",
    description: "Coating inspection credential for corrosion-control work.",
    skills: ["Coatings", "Corrosion", "Inspection"],
    careerPaths: ["Coating Inspector", "Corrosion Engineer", "QA/QC Inspector"],
    officialUrl: "https://www.ampp.org/"
  },
  {
    id: "compex-foundation",
    name: "CompEx Foundation",
    provider: "CompEx",
    category: "Engineering",
    level: "Foundation",
    description: "Foundation certification for hazardous-area electrical competencies.",
    skills: ["Hazardous Areas", "Electrical", "Safety"],
    careerPaths: ["Electrical Engineer", "ELV Engineer", "Hazardous Area Technician"],
    officialUrl: "https://compexcertification.com/"
  },

  // ============================================================
  // SOFTWARE & PROGRAMMING
  // ============================================================

  {
    id: "oracle-java-se-developer",
    name: "Oracle Certified Professional: Java SE Developer",
    provider: "Oracle",
    category: "Software & Programming",
    level: "Professional",
    description: "Professional Java development credential.",
    skills: ["Java", "Object-Oriented Programming", "Software Development"],
    careerPaths: ["Java Developer", "Software Engineer", "Backend Developer"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "oracle-java-se-17",
    name: "Oracle Certified Professional: Java SE 17 Developer",
    provider: "Oracle",
    category: "Software & Programming",
    level: "Professional",
    description: "Validates modern Java SE development skills.",
    skills: ["Java", "Java SE", "Software Development"],
    careerPaths: ["Java Developer", "Backend Developer", "Software Engineer"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "pcap-python",
    name: "PCAP: Certified Associate Python Programmer",
    provider: "Python Institute",
    category: "Software & Programming",
    level: "Associate",
    description: "Associate credential for Python programming fundamentals.",
    skills: ["Python", "Programming", "OOP"],
    careerPaths: ["Python Developer", "Junior Software Developer", "Automation Developer"],
    officialUrl: "https://pythoninstitute.org/pcap"
  },
  {
    id: "pcpp1-python",
    name: "PCPP1: Certified Professional Python Programmer",
    provider: "Python Institute",
    category: "Software & Programming",
    level: "Professional",
    description: "Professional Python programming credential.",
    skills: ["Python", "Advanced Programming", "OOP"],
    careerPaths: ["Python Developer", "Software Engineer", "Automation Engineer"],
    officialUrl: "https://pythoninstitute.org/pcpp1"
  },
  {
    id: "unity-associate-programmer",
    name: "Unity Certified Associate: Programmer",
    provider: "Unity",
    category: "Software & Programming",
    level: "Associate",
    description: "Entry-level credential for programming with Unity.",
    skills: ["Unity", "C#", "Game Development"],
    careerPaths: ["Game Developer", "Unity Developer", "Interactive Developer"],
    officialUrl: "https://unity.com/learn/certification"
  },
  {
    id: "mongodb-associate-developer",
    name: "MongoDB Associate Developer",
    provider: "MongoDB",
    category: "Software & Programming",
    level: "Associate",
    description: "Validates application-development skills with MongoDB.",
    skills: ["MongoDB", "NoSQL", "Application Development"],
    careerPaths: ["Backend Developer", "Full Stack Developer", "Database Developer"],
    officialUrl: "https://learn.mongodb.com/pages/certification"
  },
  {
    id: "github-foundations",
    name: "GitHub Foundations",
    provider: "GitHub",
    category: "Software & Programming",
    level: "Foundation",
    description: "Foundational credential for GitHub and modern development workflows.",
    skills: ["GitHub", "Git", "Collaboration"],
    careerPaths: ["Developer", "DevOps Engineer", "Software Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/github-foundations/"
  },
  {
    id: "github-actions",
    name: "GitHub Actions",
    provider: "GitHub",
    category: "Software & Programming",
    level: "Professional",
    description: "Validates GitHub Actions and CI/CD workflow skills.",
    skills: ["GitHub Actions", "CI/CD", "Automation"],
    careerPaths: ["DevOps Engineer", "Developer", "Platform Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "github-administration",
    name: "GitHub Administration",
    provider: "GitHub",
    category: "Software & Programming",
    level: "Professional",
    description: "Validates administration of GitHub environments.",
    skills: ["GitHub", "Administration", "Security"],
    careerPaths: ["GitHub Administrator", "DevOps Engineer", "Platform Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "github-advanced-security",
    name: "GitHub Advanced Security",
    provider: "GitHub",
    category: "Software & Programming",
    level: "Professional",
    description: "Validates application-security workflows using GitHub Advanced Security.",
    skills: ["GitHub", "AppSec", "Code Security"],
    careerPaths: ["Application Security Engineer", "DevSecOps Engineer", "Security Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },

  // ============================================================
  // IT & NETWORKING
  // ============================================================

  {
    id: "cisco-ccna",
    name: "Cisco CCNA",
    provider: "Cisco",
    category: "IT & Networking",
    level: "Associate",
    description: "Validates foundational networking, routing, switching and security knowledge.",
    skills: ["Networking", "Routing", "Switching"],
    careerPaths: ["Network Engineer", "Network Administrator", "IT Support Engineer"],
    officialUrl: "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/enterprise/ccna/index.html"
  },
  {
    id: "cisco-ccnp-enterprise",
    name: "Cisco CCNP Enterprise",
    provider: "Cisco",
    category: "IT & Networking",
    level: "Professional",
    description: "Advanced enterprise networking credential.",
    skills: ["Networking", "Routing", "Switching"],
    careerPaths: ["Network Engineer", "Network Architect", "Infrastructure Engineer"],
    officialUrl: "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/enterprise/ccnp-enterprise/index.html"
  },
  {
    id: "cisco-ccst-networking",
    name: "Cisco CCST Networking",
    provider: "Cisco",
    category: "IT & Networking",
    level: "Foundation",
    description: "Entry-level networking credential.",
    skills: ["Networking", "TCP/IP", "Troubleshooting"],
    careerPaths: ["Network Technician", "IT Support Technician", "Junior Network Engineer"],
    officialUrl: "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/entry-level/ccst-networking/index.html"
  },
  {
    id: "comptia-a-plus",
    name: "CompTIA A+",
    provider: "CompTIA",
    category: "IT & Networking",
    level: "Foundation",
    description: "Foundational IT support and hardware/software credential.",
    skills: ["IT Support", "Hardware", "Troubleshooting"],
    careerPaths: ["IT Support Specialist", "Help Desk Technician", "Desktop Support"],
    officialUrl: "https://www.comptia.org/certifications/a"
  },
  {
    id: "comptia-network-plus",
    name: "CompTIA Network+",
    provider: "CompTIA",
    category: "IT & Networking",
    level: "Associate",
    description: "Vendor-neutral networking credential.",
    skills: ["Networking", "TCP/IP", "Infrastructure"],
    careerPaths: ["Network Technician", "Network Administrator", "IT Support Engineer"],
    officialUrl: "https://www.comptia.org/certifications/network"
  },
  {
    id: "comptia-server-plus",
    name: "CompTIA Server+",
    provider: "CompTIA",
    category: "IT & Networking",
    level: "Professional",
    description: "Vendor-neutral server administration credential.",
    skills: ["Servers", "Infrastructure", "Administration"],
    careerPaths: ["Server Administrator", "Systems Administrator", "Infrastructure Technician"],
    officialUrl: "https://www.comptia.org/certifications/server"
  },
  {
    id: "comptia-linux-plus",
    name: "CompTIA Linux+",
    provider: "CompTIA",
    category: "IT & Networking",
    level: "Professional",
    description: "Linux administration and troubleshooting credential.",
    skills: ["Linux", "Administration", "Security"],
    careerPaths: ["Linux Administrator", "Systems Administrator", "DevOps Engineer"],
    officialUrl: "https://www.comptia.org/certifications/linux"
  },
  {
    id: "comptia-cloud-plus",
    name: "CompTIA Cloud+",
    provider: "CompTIA",
    category: "IT & Networking",
    level: "Professional",
    description: "Vendor-neutral cloud infrastructure credential.",
    skills: ["Cloud", "Infrastructure", "Virtualization"],
    careerPaths: ["Cloud Engineer", "Systems Administrator", "Cloud Support Engineer"],
    officialUrl: "https://www.comptia.org/certifications/cloud"
  },
  {
    id: "itil-4-foundation",
    name: "ITIL 4 Foundation",
    provider: "PeopleCert",
    category: "IT & Networking",
    level: "Foundation",
    description: "Foundational IT service-management credential.",
    skills: ["ITSM", "Service Management", "Processes"],
    careerPaths: ["IT Service Manager", "Service Desk Analyst", "IT Operations Analyst"],
    officialUrl: "https://www.peoplecert.org/"
  },
  {
    id: "red-hat-rhcsa",
    name: "Red Hat Certified System Administrator",
    provider: "Red Hat",
    category: "IT & Networking",
    level: "Associate",
    description: "Validates Linux system-administration skills.",
    skills: ["Linux", "Red Hat", "System Administration"],
    careerPaths: ["Linux Administrator", "Systems Administrator", "DevOps Engineer"],
    officialUrl: "https://www.redhat.com/en/services/certification"
  },
  {
    id: "red-hat-rhce",
    name: "Red Hat Certified Engineer",
    provider: "Red Hat",
    category: "IT & Networking",
    level: "Professional",
    description: "Advanced Red Hat Linux and automation credential.",
    skills: ["Linux", "Ansible", "Automation"],
    careerPaths: ["Linux Engineer", "Automation Engineer", "DevOps Engineer"],
    officialUrl: "https://www.redhat.com/en/services/certification"
  },
  {
    id: "juniper-junos-associate",
    name: "Juniper Networks Certified Associate - Junos",
    provider: "Juniper Networks",
    category: "IT & Networking",
    level: "Associate",
    description: "Entry-level Junos networking credential.",
    skills: ["Junos", "Networking", "Routing"],
    careerPaths: ["Network Engineer", "Network Administrator", "NOC Engineer"],
    officialUrl: "https://www.juniper.net/us/en/training/certification.html"
  },
  {
    id: "hashicorp-terraform-associate",
    name: "HashiCorp Terraform Associate",
    provider: "HashiCorp",
    category: "IT & Networking",
    level: "Associate",
    description: "Foundational infrastructure-as-code credential.",
    skills: ["Terraform", "Infrastructure as Code", "Cloud"],
    careerPaths: ["DevOps Engineer", "Cloud Engineer", "Platform Engineer"],
    officialUrl: "https://developer.hashicorp.com/certifications"
  },
  {
    id: "kubernetes-cka",
    name: "Certified Kubernetes Administrator",
    provider: "CNCF",
    category: "IT & Networking",
    level: "Professional",
    description: "Professional Kubernetes administration credential.",
    skills: ["Kubernetes", "Containers", "Linux"],
    careerPaths: ["Kubernetes Administrator", "DevOps Engineer", "Platform Engineer"],
    officialUrl: "https://training.linuxfoundation.org/certification/certified-kubernetes-administrator-cka/"
  },
    // ============================================================
  // CYBERSECURITY
  // ============================================================

  {
    id: "isc2-certified-in-cybersecurity",
    name: "ISC2 Certified in Cybersecurity",
    provider: "ISC2",
    category: "Cybersecurity",
    level: "Foundation",
    description: "Entry-level cybersecurity credential covering core security concepts.",
    skills: ["Cybersecurity", "Security Fundamentals", "Risk"],
    careerPaths: ["Cybersecurity Analyst", "Security Technician", "IT Security Specialist"],
    officialUrl: "https://www.isc2.org/certifications/cc"
  },
  {
    id: "isc2-cissp",
    name: "CISSP",
    provider: "ISC2",
    category: "Cybersecurity",
    level: "Professional",
    description: "Advanced cybersecurity credential for experienced security professionals.",
    skills: ["Security Architecture", "Risk", "Governance"],
    careerPaths: ["Security Architect", "Security Manager", "CISO"],
    officialUrl: "https://www.isc2.org/certifications/cissp"
  },
  {
    id: "isc2-cc",
    name: "Certified in Cybersecurity",
    provider: "ISC2",
    category: "Cybersecurity",
    level: "Foundation",
    description: "Foundation credential for people beginning a cybersecurity career.",
    skills: ["Cybersecurity", "Networking", "Security"],
    careerPaths: ["Cybersecurity Analyst", "SOC Analyst", "Security Technician"],
    officialUrl: "https://www.isc2.org/certifications/cc"
  },
  {
    id: "isaca-cism",
    name: "CISM",
    provider: "ISACA",
    category: "Cybersecurity",
    level: "Professional",
    description: "Professional credential focused on information security management.",
    skills: ["Security Management", "Governance", "Risk"],
    careerPaths: ["Security Manager", "Information Security Manager", "CISO"],
    officialUrl: "https://www.isaca.org/credentialing/cism"
  },
  {
    id: "isaca-cisa",
    name: "CISA",
    provider: "ISACA",
    category: "Cybersecurity",
    level: "Professional",
    description: "Professional credential for information systems audit and assurance.",
    skills: ["IT Audit", "Assurance", "Governance"],
    careerPaths: ["IT Auditor", "IT Risk Analyst", "GRC Specialist"],
    officialUrl: "https://www.isaca.org/credentialing/cisa"
  },
  {
    id: "isaca-crisc",
    name: "CRISC",
    provider: "ISACA",
    category: "Cybersecurity",
    level: "Professional",
    description: "Credential focused on IT risk management and information systems controls.",
    skills: ["IT Risk", "Controls", "Governance"],
    careerPaths: ["IT Risk Manager", "Security Analyst", "GRC Analyst"],
    officialUrl: "https://www.isaca.org/credentialing/crisc"
  },
  {
    id: "comptia-security-plus",
    name: "CompTIA Security+",
    provider: "CompTIA",
    category: "Cybersecurity",
    level: "Associate",
    description: "Vendor-neutral cybersecurity credential covering core security skills.",
    skills: ["Cybersecurity", "Network Security", "Risk"],
    careerPaths: ["Cybersecurity Analyst", "Security Technician", "SOC Analyst"],
    officialUrl: "https://www.comptia.org/certifications/security"
  },
  {
    id: "comptia-cysa-plus",
    name: "CompTIA CySA+",
    provider: "CompTIA",
    category: "Cybersecurity",
    level: "Professional",
    description: "Cybersecurity analytics and threat-detection credential.",
    skills: ["Threat Detection", "SIEM", "Security Analytics"],
    careerPaths: ["SOC Analyst", "Cybersecurity Analyst", "Threat Analyst"],
    officialUrl: "https://www.comptia.org/certifications/cybersecurity-analyst"
  },
  {
    id: "comptia-pentest-plus",
    name: "CompTIA PenTest+",
    provider: "CompTIA",
    category: "Cybersecurity",
    level: "Professional",
    description: "Credential covering penetration testing and vulnerability assessment.",
    skills: ["Penetration Testing", "Vulnerability", "Security"],
    careerPaths: ["Penetration Tester", "Security Analyst", "Security Consultant"],
    officialUrl: "https://www.comptia.org/certifications/pentest"
  },
  {
    id: "giac-security-essentials",
    name: "GIAC Security Essentials",
    provider: "GIAC",
    category: "Cybersecurity",
    level: "Professional",
    description: "Hands-on credential covering practical cybersecurity fundamentals.",
    skills: ["Network Security", "Incident Response", "Linux"],
    careerPaths: ["Security Analyst", "SOC Analyst", "Security Engineer"],
    officialUrl: "https://www.giac.org/certifications/"
  },
  {
    id: "giac-incident-handler",
    name: "GIAC Certified Incident Handler",
    provider: "GIAC",
    category: "Cybersecurity",
    level: "Professional",
    description: "Credential focused on incident response and threat handling.",
    skills: ["Incident Response", "Threat Hunting", "Forensics"],
    careerPaths: ["Incident Responder", "SOC Analyst", "Threat Hunter"],
    officialUrl: "https://www.giac.org/certifications/"
  },
  {
    id: "giac-penetration-tester",
    name: "GIAC Penetration Tester",
    provider: "GIAC",
    category: "Cybersecurity",
    level: "Professional",
    description: "Practical credential covering penetration testing techniques.",
    skills: ["Penetration Testing", "Security Testing", "Vulnerability"],
    careerPaths: ["Penetration Tester", "Security Consultant", "Red Team Analyst"],
    officialUrl: "https://www.giac.org/certifications/"
  },
  {
    id: "ceh",
    name: "Certified Ethical Hacker",
    provider: "EC-Council",
    category: "Cybersecurity",
    level: "Professional",
    description: "Credential covering ethical hacking and security testing.",
    skills: ["Ethical Hacking", "Penetration Testing", "Security"],
    careerPaths: ["Ethical Hacker", "Penetration Tester", "Security Analyst"],
    officialUrl: "https://www.eccouncil.org/train-certify/certified-ethical-hacker-ceh/"
  },
  {
    id: "chfi",
    name: "Computer Hacking Forensic Investigator",
    provider: "EC-Council",
    category: "Cybersecurity",
    level: "Professional",
    description: "Credential covering digital forensics and cyber investigations.",
    skills: ["Digital Forensics", "Incident Response", "Investigation"],
    careerPaths: ["Forensic Analyst", "Incident Responder", "Cybercrime Investigator"],
    officialUrl: "https://www.eccouncil.org/train-certify/computer-hacking-forensic-investigator-chfi/"
  },

  // ============================================================
  // CLOUD & DEVOPS
  // ============================================================

  {
    id: "aws-cloud-practitioner",
    name: "AWS Certified Cloud Practitioner",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Foundation",
    description: "Foundational AWS credential covering core cloud concepts.",
    skills: ["AWS", "Cloud Fundamentals", "Cloud Security"],
    careerPaths: ["Cloud Support Associate", "Cloud Analyst", "Junior Cloud Engineer"],
    officialUrl: "https://aws.amazon.com/certification/certified-cloud-practitioner/"
  },
  {
    id: "aws-solutions-architect-associate",
    name: "AWS Certified Solutions Architect - Associate",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for designing AWS cloud solutions.",
    skills: ["AWS", "Architecture", "Cloud"],
    careerPaths: ["Cloud Engineer", "Solutions Architect", "Cloud Consultant"],
    officialUrl: "https://aws.amazon.com/certification/certified-solutions-architect-associate/"
  },
  {
    id: "aws-developer-associate",
    name: "AWS Certified Developer - Associate",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for developing applications on AWS.",
    skills: ["AWS", "Development", "Cloud"],
    careerPaths: ["Cloud Developer", "Software Engineer", "AWS Developer"],
    officialUrl: "https://aws.amazon.com/certification/certified-developer-associate/"
  },
  {
    id: "aws-cloudops-engineer",
    name: "AWS Certified CloudOps Engineer - Associate",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for operating and managing AWS environments.",
    skills: ["AWS", "Cloud Operations", "Infrastructure"],
    careerPaths: ["Cloud Operations Engineer", "Cloud Administrator", "DevOps Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-data-engineer-associate",
    name: "AWS Certified Data Engineer - Associate",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for data engineering on AWS.",
    skills: ["AWS", "Data Engineering", "ETL"],
    careerPaths: ["Data Engineer", "Cloud Data Engineer", "Analytics Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-ml-engineer-associate",
    name: "AWS Certified Machine Learning Engineer - Associate",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for machine learning engineering on AWS.",
    skills: ["AWS", "Machine Learning", "MLOps"],
    careerPaths: ["ML Engineer", "MLOps Engineer", "Cloud ML Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-devops-professional",
    name: "AWS Certified DevOps Engineer - Professional",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional AWS credential focused on DevOps and automation.",
    skills: ["AWS", "DevOps", "CI/CD"],
    careerPaths: ["DevOps Engineer", "Platform Engineer", "Cloud Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-solutions-architect-professional",
    name: "AWS Certified Solutions Architect - Professional",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional credential for complex AWS architecture.",
    skills: ["AWS", "Cloud Architecture", "Enterprise Architecture"],
    careerPaths: ["Solutions Architect", "Cloud Architect", "Enterprise Architect"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-security-specialty",
    name: "AWS Certified Security - Specialty",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Specialty",
    description: "Specialty credential focused on AWS security.",
    skills: ["AWS", "Cloud Security", "Identity"],
    careerPaths: ["Cloud Security Engineer", "Security Architect", "Security Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "aws-advanced-networking-specialty",
    name: "AWS Certified Advanced Networking - Specialty",
    provider: "AWS",
    category: "Cloud & DevOps",
    level: "Specialty",
    description: "Specialty credential for advanced AWS networking.",
    skills: ["AWS", "Networking", "Hybrid Cloud"],
    careerPaths: ["Cloud Network Engineer", "Network Architect", "Cloud Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "google-cloud-digital-leader",
    name: "Google Cloud Digital Leader",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Foundation",
    description: "Foundational credential for cloud and digital transformation.",
    skills: ["Google Cloud", "Cloud Fundamentals", "Digital Transformation"],
    careerPaths: ["Cloud Analyst", "Business Analyst", "Cloud Consultant"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-digital-leader"
  },
  {
    id: "google-associate-cloud-engineer",
    name: "Google Associate Cloud Engineer",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for deploying and operating Google Cloud solutions.",
    skills: ["Google Cloud", "Cloud Engineering", "Operations"],
    careerPaths: ["Cloud Engineer", "Cloud Administrator", "DevOps Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-engineer"
  },
  {
    id: "google-cloud-architect",
    name: "Google Professional Cloud Architect",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional Google Cloud architecture credential.",
    skills: ["Google Cloud", "Architecture", "Cloud"],
    careerPaths: ["Cloud Architect", "Solutions Architect", "Cloud Consultant"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-architect"
  },
  {
    id: "google-cloud-devops",
    name: "Google Professional Cloud DevOps Engineer",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional credential for Google Cloud DevOps and reliability practices.",
    skills: ["Google Cloud", "DevOps", "SRE"],
    careerPaths: ["DevOps Engineer", "SRE", "Platform Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-devops-engineer"
  },
  {
    id: "google-cloud-security",
    name: "Google Professional Cloud Security Engineer",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional Google Cloud security credential.",
    skills: ["Google Cloud", "Cloud Security", "IAM"],
    careerPaths: ["Cloud Security Engineer", "Security Architect", "Cloud Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-security-engineer"
  },
  {
    id: "google-cloud-network-engineer",
    name: "Google Professional Cloud Network Engineer",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional Google Cloud networking credential.",
    skills: ["Google Cloud", "Networking", "Cloud"],
    careerPaths: ["Cloud Network Engineer", "Network Architect", "Cloud Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/cloud-network-engineer"
  },
  {
    id: "azure-fundamentals",
    name: "Microsoft Azure Fundamentals",
    provider: "Microsoft",
    category: "Cloud & DevOps",
    level: "Foundation",
    description: "Foundational Microsoft Azure cloud credential.",
    skills: ["Azure", "Cloud Fundamentals", "Infrastructure"],
    careerPaths: ["Cloud Support Associate", "Cloud Analyst", "Junior Cloud Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-fundamentals/"
  },
  {
    id: "azure-administrator-associate",
    name: "Microsoft Azure Administrator Associate",
    provider: "Microsoft",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for Azure administration.",
    skills: ["Azure", "Administration", "Cloud"],
    careerPaths: ["Azure Administrator", "Cloud Engineer", "Systems Administrator"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-administrator/"
  },
  {
    id: "azure-network-engineer",
    name: "Microsoft Azure Network Engineer Associate",
    provider: "Microsoft",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for Azure networking.",
    skills: ["Azure", "Networking", "Cloud"],
    careerPaths: ["Cloud Network Engineer", "Network Engineer", "Azure Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-network-engineer-associate/"
  },
  {
    id: "azure-solutions-architect",
    name: "Microsoft Azure Solutions Architect Expert",
    provider: "Microsoft",
    category: "Cloud & DevOps",
    level: "Expert",
    description: "Expert credential for Azure solution architecture.",
    skills: ["Azure", "Architecture", "Cloud"],
    careerPaths: ["Solutions Architect", "Cloud Architect", "Azure Architect"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-solutions-architect/"
  },
  {
    id: "azure-devops-engineer",
    name: "Microsoft Azure DevOps Engineer Expert",
    provider: "Microsoft",
    category: "Cloud & DevOps",
    level: "Expert",
    description: "Expert credential for Azure DevOps practices.",
    skills: ["Azure", "DevOps", "CI/CD"],
    careerPaths: ["DevOps Engineer", "Platform Engineer", "Cloud Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/devops-engineer/"
  },
  {
    id: "terraform-associate",
    name: "HashiCorp Terraform Associate",
    provider: "HashiCorp",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Foundational infrastructure-as-code credential.",
    skills: ["Terraform", "Infrastructure as Code", "Cloud"],
    careerPaths: ["DevOps Engineer", "Cloud Engineer", "Platform Engineer"],
    officialUrl: "https://developer.hashicorp.com/certifications"
  },
  {
    id: "vault-associate",
    name: "HashiCorp Vault Associate",
    provider: "HashiCorp",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Credential focused on secrets management and security.",
    skills: ["Vault", "Secrets Management", "Security"],
    careerPaths: ["Security Engineer", "DevOps Engineer", "Platform Engineer"],
    officialUrl: "https://developer.hashicorp.com/certifications"
  },

  // ============================================================
  // AI & MACHINE LEARNING
  // ============================================================

  {
    id: "aws-ai-practitioner",
    name: "AWS Certified AI Practitioner",
    provider: "AWS",
    category: "AI & Machine Learning",
    level: "Foundation",
    description: "Foundational credential covering AI and generative AI concepts.",
    skills: ["AWS", "AI", "Generative AI"],
    careerPaths: ["AI Analyst", "Cloud Analyst", "AI Product Specialist"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "google-generative-ai-leader",
    name: "Google Generative AI Leader",
    provider: "Google Cloud",
    category: "AI & Machine Learning",
    level: "Foundation",
    description: "Credential focused on generative AI leadership and business use.",
    skills: ["Generative AI", "AI Strategy", "Leadership"],
    careerPaths: ["AI Product Manager", "AI Consultant", "Business AI Lead"],
    officialUrl: "https://cloud.google.com/learn/certification"
  },
  {
    id: "azure-ai-fundamentals",
    name: "Microsoft Azure AI Fundamentals",
    provider: "Microsoft",
    category: "AI & Machine Learning",
    level: "Foundation",
    description: "Foundational credential for AI concepts and Azure AI services.",
    skills: ["Azure AI", "AI Fundamentals", "Machine Learning"],
    careerPaths: ["AI Analyst", "AI Support Specialist", "Junior AI Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-fundamentals/"
  },
  {
    id: "azure-ai-engineer",
    name: "Microsoft Azure AI Engineer Associate",
    provider: "Microsoft",
    category: "AI & Machine Learning",
    level: "Associate",
    description: "Associate credential for implementing AI solutions on Azure.",
    skills: ["Azure AI", "Machine Learning", "AI Engineering"],
    careerPaths: ["AI Engineer", "ML Engineer", "Azure AI Developer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-engineer/"
  },
  {
    id: "google-machine-learning-engineer",
    name: "Google Professional Machine Learning Engineer",
    provider: "Google Cloud",
    category: "AI & Machine Learning",
    level: "Professional",
    description: "Professional credential for production machine learning on Google Cloud.",
    skills: ["Machine Learning", "MLOps", "Google Cloud"],
    careerPaths: ["ML Engineer", "AI Engineer", "MLOps Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/machine-learning-engineer"
  },
  {
    id: "nvidia-generative-ai",
    name: "NVIDIA Certified Associate: Generative AI LLMs",
    provider: "NVIDIA",
    category: "AI & Machine Learning",
    level: "Associate",
    description: "Associate credential covering generative AI and large language models.",
    skills: ["Generative AI", "LLMs", "NVIDIA"],
    careerPaths: ["AI Developer", "ML Engineer", "AI Analyst"],
    officialUrl: "https://www.nvidia.com/en-us/learn/certification/"
  },
  {
    id: "databricks-generative-ai-engineer",
    name: "Databricks Certified Generative AI Engineer Associate",
    provider: "Databricks",
    category: "AI & Machine Learning",
    level: "Associate",
    description: "Associate credential for generative AI application development.",
    skills: ["Databricks", "GenAI", "LLMs"],
    careerPaths: ["AI Engineer", "ML Engineer", "Data Engineer"],
    officialUrl: "https://www.databricks.com/learn/certification"
  },
  {
    id: "databricks-ml-associate",
    name: "Databricks Certified Machine Learning Associate",
    provider: "Databricks",
    category: "AI & Machine Learning",
    level: "Associate",
    description: "Associate credential for machine learning workflows in Databricks.",
    skills: ["Databricks", "Machine Learning", "MLOps"],
    careerPaths: ["ML Engineer", "Data Scientist", "Data Engineer"],
    officialUrl: "https://www.databricks.com/learn/certification"
  },
  {
    id: "databricks-ml-professional",
    name: "Databricks Certified Machine Learning Professional",
    provider: "Databricks",
    category: "AI & Machine Learning",
    level: "Professional",
    description: "Professional machine learning credential for Databricks.",
    skills: ["Databricks", "Machine Learning", "MLOps"],
    careerPaths: ["ML Engineer", "ML Architect", "Data Scientist"],
    officialUrl: "https://www.databricks.com/learn/certification"
  },
  {
    id: "ibm-ai-engineering",
    name: "IBM AI Engineering Professional Certificate",
    provider: "IBM",
    category: "AI & Machine Learning",
    level: "Professional",
    description: "Professional learning credential covering applied AI engineering.",
    skills: ["AI", "Python", "Machine Learning"],
    careerPaths: ["AI Engineer", "ML Engineer", "Python Developer"],
    officialUrl: "https://www.coursera.org/professional-certificates/ibm-ai-engineering"
  },
  {
    id: "ibm-generative-ai-engineering",
    name: "IBM Generative AI Engineering Professional Certificate",
    provider: "IBM",
    category: "AI & Machine Learning",
    level: "Professional",
    description: "Professional learning credential for generative AI engineering.",
    skills: ["Generative AI", "LLMs", "Python"],
    careerPaths: ["GenAI Engineer", "AI Engineer", "ML Engineer"],
    officialUrl: "https://www.coursera.org/"
  },
  {
    id: "sas-ai-machine-learning",
    name: "SAS Certified AI and Machine Learning Professional",
    provider: "SAS",
    category: "AI & Machine Learning",
    level: "Professional",
    description: "Professional credential covering AI and machine learning using SAS.",
    skills: ["SAS", "AI", "Machine Learning"],
    careerPaths: ["Data Scientist", "ML Engineer", "Analytics Consultant"],
    officialUrl: "https://www.sas.com/en_us/certification.html"
  },

  // ============================================================
  // DATA & ANALYTICS
  // ============================================================

  {
    id: "power-bi-data-analyst",
    name: "Microsoft Power BI Data Analyst Associate",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for data analysis and Power BI.",
    skills: ["Power BI", "Data Analysis", "DAX"],
    careerPaths: ["Data Analyst", "BI Analyst", "Power BI Developer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/data-analyst-associate/"
  },
  {
    id: "fabric-analytics-engineer",
    name: "Microsoft Fabric Analytics Engineer Associate",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for analytics engineering in Microsoft Fabric.",
    skills: ["Fabric", "Analytics", "Data Engineering"],
    careerPaths: ["Analytics Engineer", "Data Engineer", "BI Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "azure-data-fundamentals",
    name: "Microsoft Azure Data Fundamentals",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Foundation",
    description: "Foundational credential covering core data concepts on Azure.",
    skills: ["Azure", "Data", "Databases"],
    careerPaths: ["Data Analyst", "Data Support Specialist", "Junior Data Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-data-fundamentals/"
  },
  {
    id: "azure-database-administrator",
    name: "Microsoft Azure Database Administrator Associate",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for Azure database administration.",
    skills: ["Azure SQL", "Databases", "Administration"],
    careerPaths: ["Database Administrator", "Azure Database Engineer", "Data Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-database-administrator-associate/"
  },
  {
    id: "google-data-engineer",
    name: "Google Professional Data Engineer",
    provider: "Google Cloud",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional credential for designing data systems on Google Cloud.",
    skills: ["Data Engineering", "Google Cloud", "ETL"],
    careerPaths: ["Data Engineer", "Analytics Engineer", "Cloud Data Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification/data-engineer"
  },
  {
    id: "google-cloud-data-practitioner",
    name: "Google Cloud Data Practitioner",
    provider: "Google Cloud",
    category: "Data & Analytics",
    level: "Foundation",
    description: "Credential covering practical data skills in Google Cloud.",
    skills: ["Data", "Google Cloud", "Analytics"],
    careerPaths: ["Data Analyst", "Data Practitioner", "BI Analyst"],
    officialUrl: "https://cloud.google.com/learn/certification"
  },
  {
    id: "aws-data-engineer",
    name: "AWS Certified Data Engineer - Associate",
    provider: "AWS",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for AWS data engineering.",
    skills: ["AWS", "Data Engineering", "ETL"],
    careerPaths: ["Data Engineer", "Analytics Engineer", "Cloud Data Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "sas-data-scientist",
    name: "SAS Certified Data Scientist",
    provider: "SAS",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional data science credential using SAS.",
    skills: ["SAS", "Data Science", "Machine Learning"],
    careerPaths: ["Data Scientist", "ML Analyst", "Analytics Consultant"],
    officialUrl: "https://www.sas.com/en_us/certification.html"
  },
  {
    id: "tableau-data-analyst",
    name: "Tableau Certified Data Analyst",
    provider: "Tableau",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional credential for Tableau data analysis.",
    skills: ["Tableau", "Data Visualization", "Analytics"],
    careerPaths: ["Data Analyst", "BI Analyst", "Data Visualization Specialist"],
    officialUrl: "https://www.tableau.com/learn/certification"
  },
  {
    id: "tableau-consultant",
    name: "Tableau Certified Consultant",
    provider: "Tableau",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional Tableau consulting credential.",
    skills: ["Tableau", "BI", "Consulting"],
    careerPaths: ["BI Consultant", "Tableau Consultant", "Data Analyst"],
    officialUrl: "https://www.tableau.com/learn/certification"
  },
  {
    id: "snowpro-core",
    name: "SnowPro Core Certification",
    provider: "Snowflake",
    category: "Data & Analytics",
    level: "Associate",
    description: "Foundational Snowflake data-platform credential.",
    skills: ["Snowflake", "Data Warehousing", "SQL"],
    careerPaths: ["Data Engineer", "Analytics Engineer", "Snowflake Developer"],
    officialUrl: "https://www.snowflake.com/en/certifications/"
  },
  {
    id: "snowpro-data-engineer",
    name: "SnowPro Advanced: Data Engineer",
    provider: "Snowflake",
    category: "Data & Analytics",
    level: "Professional",
    description: "Advanced Snowflake data-engineering credential.",
    skills: ["Snowflake", "Data Engineering", "SQL"],
    careerPaths: ["Data Engineer", "Cloud Data Engineer", "Analytics Engineer"],
    officialUrl: "https://www.snowflake.com/en/certifications/"
  },
  {
    id: "mongodb-data-modeler",
    name: "MongoDB Associate Data Modeler",
    provider: "MongoDB",
    category: "Data & Analytics",
    level: "Associate",
    description: "Validates data-modeling skills for MongoDB.",
    skills: ["MongoDB", "Data Modeling", "NoSQL"],
    careerPaths: ["Data Modeler", "Database Developer", "Data Engineer"],
    officialUrl: "https://learn.mongodb.com/pages/certification"
  },
  {
    id: "oracle-sql-associate",
    name: "Oracle Database SQL Certified Associate",
    provider: "Oracle",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for Oracle SQL and database fundamentals.",
    skills: ["Oracle", "SQL", "Databases"],
    careerPaths: ["SQL Developer", "Database Developer", "Data Analyst"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "ibm-data-engineering",
    name: "IBM Data Engineering Professional Certificate",
    provider: "IBM",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional learning credential covering practical data engineering.",
    skills: ["Python", "SQL", "Data Engineering"],
    careerPaths: ["Data Engineer", "ETL Developer", "Database Developer"],
    officialUrl: "https://www.coursera.org/"
  },
  // ============================================================
  // PROJECT & BUSINESS MANAGEMENT
  // ============================================================

  {
    id: "pmi-pmp",
    name: "PMP",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Professional",
    description: "Globally recognized professional credential for project management.",
    skills: ["Project Management", "Leadership", "Planning"],
    careerPaths: ["Project Manager", "Program Manager", "Project Lead"],
    officialUrl: "https://www.pmi.org/certifications/project-management-pmp"
  },
  {
    id: "pmi-capm",
    name: "CAPM",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Foundational project-management credential for early-career professionals.",
    skills: ["Project Management", "Planning", "Agile"],
    careerPaths: ["Project Coordinator", "Project Analyst", "Assistant Project Manager"],
    officialUrl: "https://www.pmi.org/certifications/certified-associate-capm"
  },
  {
    id: "pmi-pgmp",
    name: "PgMP",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Professional",
    description: "Advanced credential for managing multiple related projects as programs.",
    skills: ["Program Management", "Strategy", "Leadership"],
    careerPaths: ["Program Manager", "Program Director", "Portfolio Manager"],
    officialUrl: "https://www.pmi.org/certifications/program-management-pgmp"
  },
  {
    id: "pmi-pfmp",
    name: "PfMP",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Expert",
    description: "Advanced credential for portfolio management and strategic alignment.",
    skills: ["Portfolio Management", "Strategy", "Governance"],
    careerPaths: ["Portfolio Manager", "PMO Director", "Program Director"],
    officialUrl: "https://www.pmi.org/certifications/portfolio-management-pfmp"
  },
  {
    id: "pmi-acp",
    name: "PMI Agile Certified Practitioner",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Professional",
    description: "Professional credential covering agile approaches and practices.",
    skills: ["Agile", "Scrum", "Kanban"],
    careerPaths: ["Agile Project Manager", "Scrum Master", "Agile Coach"],
    officialUrl: "https://www.pmi.org/certifications/agile-acp"
  },
  {
    id: "pmi-rmp",
    name: "PMI Risk Management Professional",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Professional",
    description: "Professional credential for project risk management.",
    skills: ["Risk Management", "Project Controls", "Analysis"],
    careerPaths: ["Risk Manager", "Project Manager", "Risk Analyst"],
    officialUrl: "https://www.pmi.org/certifications/risk-management-rmp"
  },
  {
    id: "pmi-pba",
    name: "PMI Professional in Business Analysis",
    provider: "PMI",
    category: "Project & Business Management",
    level: "Professional",
    description: "Professional credential for business analysis in projects.",
    skills: ["Business Analysis", "Requirements", "Stakeholders"],
    careerPaths: ["Business Analyst", "Product Analyst", "Project Manager"],
    officialUrl: "https://www.pmi.org/certifications/business-analysis-pba"
  },
  {
    id: "scrum-master-i",
    name: "Professional Scrum Master I",
    provider: "Scrum.org",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Professional assessment covering Scrum Master fundamentals.",
    skills: ["Scrum", "Agile", "Facilitation"],
    careerPaths: ["Scrum Master", "Agile Project Manager", "Delivery Lead"],
    officialUrl: "https://www.scrum.org/assessments/professional-scrum-master-certifications"
  },
  {
    id: "scrum-product-owner-i",
    name: "Professional Scrum Product Owner I",
    provider: "Scrum.org",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Professional credential for Scrum product ownership.",
    skills: ["Scrum", "Product Management", "Agile"],
    careerPaths: ["Product Owner", "Product Manager", "Business Analyst"],
    officialUrl: "https://www.scrum.org/assessments/professional-scrum-product-owner-certification"
  },
  {
    id: "prince2-foundation",
    name: "PRINCE2 Foundation",
    provider: "PeopleCert",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Foundational structured project-management credential.",
    skills: ["PRINCE2", "Project Management", "Governance"],
    careerPaths: ["Project Coordinator", "Project Manager", "PMO Analyst"],
    officialUrl: "https://www.peoplecert.org/"
  },
  {
    id: "prince2-practitioner",
    name: "PRINCE2 Practitioner",
    provider: "PeopleCert",
    category: "Project & Business Management",
    level: "Professional",
    description: "Practitioner-level project-management credential.",
    skills: ["PRINCE2", "Project Management", "Governance"],
    careerPaths: ["Project Manager", "PMO Manager", "Project Lead"],
    officialUrl: "https://www.peoplecert.org/"
  },
  {
    id: "safe-agilist",
    name: "SAFe Agilist",
    provider: "Scaled Agile",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Credential covering scaled agile practices.",
    skills: ["SAFe", "Agile", "Product Delivery"],
    careerPaths: ["Agile Manager", "Product Manager", "Scrum Master"],
    officialUrl: "https://scaledagile.com/certification/"
  },

  // ============================================================
  // FINANCE & ACCOUNTING
  // ============================================================

  {
    id: "acca",
    name: "ACCA Qualification",
    provider: "ACCA",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional accountancy qualification covering finance, reporting and audit.",
    skills: ["Accounting", "Audit", "Finance"],
    careerPaths: ["Accountant", "Financial Analyst", "Auditor"],
    officialUrl: "https://www.accaglobal.com/"
  },
  {
    id: "cfa-program",
    name: "CFA Program",
    provider: "CFA Institute",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional investment and financial-analysis credential.",
    skills: ["Investment Analysis", "Portfolio Management", "Finance"],
    careerPaths: ["Investment Analyst", "Portfolio Analyst", "Financial Analyst"],
    officialUrl: "https://www.cfainstitute.org/programs/cfa-program"
  },
  {
    id: "cia",
    name: "Certified Internal Auditor",
    provider: "IIA",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional credential for internal audit and assurance.",
    skills: ["Internal Audit", "Risk", "Controls"],
    careerPaths: ["Internal Auditor", "Risk Analyst", "Audit Manager"],
    officialUrl: "https://www.theiia.org/en/certifications/cia/"
  },
  {
    id: "frm",
    name: "Financial Risk Manager",
    provider: "GARP",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional credential for financial risk management.",
    skills: ["Risk Management", "Markets", "Quantitative Analysis"],
    careerPaths: ["Risk Analyst", "Market Risk Analyst", "Risk Manager"],
    officialUrl: "https://www.garp.org/frm"
  },
  {
    id: "cfp",
    name: "CFP Certification",
    provider: "CFP Board",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional personal-financial-planning credential.",
    skills: ["Financial Planning", "Wealth Management", "Investments"],
    careerPaths: ["Financial Planner", "Wealth Manager", "Financial Advisor"],
    officialUrl: "https://www.cfp.net/"
  },
  {
    id: "cma",
    name: "Certified Management Accountant",
    provider: "IMA",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional credential in management accounting and financial management.",
    skills: ["Management Accounting", "Finance", "Strategy"],
    careerPaths: ["Management Accountant", "Financial Analyst", "Finance Manager"],
    officialUrl: "https://www.imanet.org/ima-certifications/cma-certification"
  },
  {
    id: "acca-ifrs",
    name: "ACCA Diploma in IFRS",
    provider: "ACCA",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Credential focused on international financial reporting standards.",
    skills: ["IFRS", "Accounting", "Reporting"],
    careerPaths: ["Financial Accountant", "Reporting Specialist", "Accountant"],
    officialUrl: "https://www.accaglobal.com/"
  },
  {
    id: "chartered-accountancy-india",
    name: "Chartered Accountancy",
    provider: "ICAI",
    category: "Finance & Accounting",
    level: "Professional",
    description: "Professional accountancy pathway covering audit, tax and finance.",
    skills: ["Accounting", "Audit", "Tax"],
    careerPaths: ["Chartered Accountant", "Auditor", "Tax Consultant"],
    officialUrl: "https://www.icai.org/"
  },

  // ============================================================
  // HEALTHCARE
  // ============================================================

  {
    id: "abim-internal-medicine",
    name: "ABIM Internal Medicine Certification",
    provider: "ABIM",
    category: "Healthcare",
    level: "Professional",
    description: "Board certification for physicians in internal medicine.",
    skills: ["Internal Medicine", "Clinical Practice", "Patient Care"],
    careerPaths: ["Internal Medicine Physician", "Hospitalist", "Physician"],
    officialUrl: "https://www.abim.org/certification/becoming-certified-in-internal-medicine/"
  },
  {
    id: "ahima-rhit",
    name: "Registered Health Information Technician",
    provider: "AHIMA",
    category: "Healthcare",
    level: "Associate",
    description: "Credential for health-information and medical-records professionals.",
    skills: ["Health Information", "Medical Records", "Data"],
    careerPaths: ["Health Information Technician", "Medical Records Specialist", "Health Data Specialist"],
    officialUrl: "https://www.ahima.org/certification-careers/certifications-overview/rhit/"
  },
  {
    id: "ahima-rhia",
    name: "Registered Health Information Administrator",
    provider: "AHIMA",
    category: "Healthcare",
    level: "Professional",
    description: "Advanced credential for health-information administration.",
    skills: ["Health Information", "Privacy", "Data Governance"],
    careerPaths: ["Health Information Manager", "Health Data Manager", "Privacy Specialist"],
    officialUrl: "https://www.ahima.org/certification-careers/certifications-overview/rhia/"
  },
  {
    id: "cphq",
    name: "Certified Professional in Healthcare Quality",
    provider: "NAHQ",
    category: "Healthcare",
    level: "Professional",
    description: "Professional credential for healthcare quality improvement.",
    skills: ["Healthcare Quality", "Patient Safety", "Quality Improvement"],
    careerPaths: ["Healthcare Quality Manager", "Quality Specialist", "Patient Safety Specialist"],
    officialUrl: "https://nahq.org/cphq/"
  },
  {
    id: "cphr-risk",
    name: "Certified Professional in Healthcare Risk Management",
    provider: "ASHRM",
    category: "Healthcare",
    level: "Professional",
    description: "Professional credential for healthcare risk management.",
    skills: ["Healthcare Risk", "Compliance", "Patient Safety"],
    careerPaths: ["Healthcare Risk Manager", "Compliance Specialist", "Risk Analyst"],
    officialUrl: "https://www.ashrm.org/"
  },
  {
    id: "certified-healthcare-constructor",
    name: "Certified Healthcare Constructor",
    provider: "AHA",
    category: "Healthcare",
    level: "Professional",
    description: "Professional credential for healthcare construction.",
    skills: ["Healthcare Construction", "Facilities", "Project Management"],
    careerPaths: ["Healthcare Construction Manager", "Project Manager", "Facilities Manager"],
    officialUrl: "https://www.aha.org/"
  },
  {
    id: "certified-nurse-manager-leader",
    name: "Certified Nurse Manager and Leader",
    provider: "AONL",
    category: "Healthcare",
    level: "Professional",
    description: "Leadership credential for nurse managers.",
    skills: ["Nursing Leadership", "Healthcare Management", "Operations"],
    careerPaths: ["Nurse Manager", "Clinical Manager", "Nursing Leader"],
    officialUrl: "https://www.aonl.org/"
  },
  {
    id: "healthcare-financial-professional",
    name: "Certified Healthcare Financial Professional",
    provider: "HFMA",
    category: "Healthcare",
    level: "Professional",
    description: "Healthcare finance professional credential.",
    skills: ["Healthcare Finance", "Revenue Cycle", "Strategy"],
    careerPaths: ["Healthcare Finance Manager", "Revenue Cycle Manager", "Healthcare Analyst"],
    officialUrl: "https://www.hfma.org/"
  },

  // ============================================================
  // HR
  // ============================================================

  {
    id: "shrm-cp",
    name: "SHRM-CP",
    provider: "SHRM",
    category: "HR",
    level: "Professional",
    description: "Professional HR credential for operational people-management work.",
    skills: ["HR", "People Management", "Employment"],
    careerPaths: ["HR Specialist", "HR Generalist", "People Operations Specialist"],
    officialUrl: "https://www.shrm.org/mena/credentials/certification/shrm-cp"
  },
  {
    id: "shrm-scp",
    name: "SHRM-SCP",
    provider: "SHRM",
    category: "HR",
    level: "Expert",
    description: "Advanced HR credential for strategic people leadership.",
    skills: ["HR Strategy", "Leadership", "People Management"],
    careerPaths: ["HR Manager", "HR Director", "People Strategy Lead"],
    officialUrl: "https://www.shrm.org/credentials/certification/shrm-scp"
  },
  {
    id: "aphr",
    name: "aPHR",
    provider: "HRCI",
    category: "HR",
    level: "Foundation",
    description: "Foundational HR credential for people beginning an HR career.",
    skills: ["HR Fundamentals", "Recruiting", "Employment"],
    careerPaths: ["HR Assistant", "Recruiting Coordinator", "HR Specialist"],
    officialUrl: "https://www.hrci.org/certifications/aphr"
  },
  {
    id: "phr",
    name: "PHR",
    provider: "HRCI",
    category: "HR",
    level: "Professional",
    description: "Professional HR credential focused on operational HR knowledge.",
    skills: ["HR", "Employment Law", "Benefits"],
    careerPaths: ["HR Generalist", "HR Specialist", "HR Manager"],
    officialUrl: "https://www.hrci.org/certifications/individual-certifications/phr"
  },
  {
    id: "sphr",
    name: "SPHR",
    provider: "HRCI",
    category: "HR",
    level: "Expert",
    description: "Senior-level HR credential focused on strategic HR leadership.",
    skills: ["HR Strategy", "Leadership", "Employment"],
    careerPaths: ["HR Director", "HR Manager", "People Strategy Lead"],
    officialUrl: "https://www.hrci.org/certifications/individual-certifications/sphr"
  },
  {
    id: "gphr",
    name: "GPHR",
    provider: "HRCI",
    category: "HR",
    level: "Professional",
    description: "Global HR credential for international people-management practices.",
    skills: ["Global HR", "Employment", "HR Strategy"],
    careerPaths: ["Global HR Specialist", "HR Manager", "International HR Consultant"],
    officialUrl: "https://www.hrci.org/certifications/individual-certifications/gphr"
  },
  {
    id: "atd-talent-development",
    name: "ATD Certified Professional in Talent Development",
    provider: "ATD",
    category: "HR",
    level: "Professional",
    description: "Professional talent-development credential.",
    skills: ["Talent Development", "Learning", "Training"],
    careerPaths: ["L&D Manager", "Talent Development Manager", "Training Consultant"],
    officialUrl: "https://www.td.org/certification"
  },
  {
    id: "compensation-professional",
    name: "Certified Compensation Professional",
    provider: "WorldatWork",
    category: "HR",
    level: "Professional",
    description: "Professional credential in compensation practices.",
    skills: ["Compensation", "Benefits", "HR Analytics"],
    careerPaths: ["Compensation Analyst", "Total Rewards Specialist", "HR Manager"],
    officialUrl: "https://worldatwork.org/"
  },

  // ============================================================
  // MARKETING & SALES
  // ============================================================

  {
    id: "hubspot-digital-marketing",
    name: "HubSpot Digital Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    level: "Foundation",
    description: "Free certification covering core digital marketing concepts.",
    skills: ["Digital Marketing", "SEO", "Content"],
    careerPaths: ["Digital Marketer", "Marketing Specialist", "Content Marketer"],
    officialUrl: "https://academy.hubspot.com/courses/digital-marketing"
  },
  {
    id: "hubspot-inbound-marketing",
    name: "HubSpot Inbound Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    level: "Foundation",
    description: "Credential covering inbound marketing strategy.",
    skills: ["Inbound Marketing", "Content", "Lead Generation"],
    careerPaths: ["Inbound Marketer", "Content Strategist", "Marketing Specialist"],
    officialUrl: "https://academy.hubspot.com/courses/inbound-marketing"
  },
  {
    id: "hubspot-content-marketing",
    name: "HubSpot Content Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    level: "Foundation",
    description: "Credential focused on content strategy and marketing.",
    skills: ["Content Marketing", "Strategy", "SEO"],
    careerPaths: ["Content Marketer", "Content Strategist", "Marketing Manager"],
    officialUrl: "https://academy.hubspot.com/courses/content-marketing"
  },
  {
    id: "hubspot-social-media",
    name: "HubSpot Social Media Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    level: "Foundation",
    description: "Credential covering social-media strategy and execution.",
    skills: ["Social Media", "Content", "Marketing"],
    careerPaths: ["Social Media Manager", "Digital Marketer", "Content Manager"],
    officialUrl: "https://academy.hubspot.com/courses/social-media"
  },
  {
    id: "google-ads-search",
    name: "Google Ads Search Certification",
    provider: "Google",
    category: "Marketing & Sales",
    level: "Professional",
    description: "Credential for Google Ads search advertising.",
    skills: ["Google Ads", "SEM", "Paid Search"],
    careerPaths: ["PPC Specialist", "Digital Marketer", "SEM Specialist"],
    officialUrl: "https://skillshop.withgoogle.com/"
  },
  {
    id: "google-analytics",
    name: "Google Analytics Certification",
    provider: "Google",
    category: "Marketing & Sales",
    level: "Professional",
    description: "Credential demonstrating Google Analytics knowledge.",
    skills: ["Google Analytics", "Web Analytics", "Measurement"],
    careerPaths: ["Digital Analyst", "Marketing Analyst", "Web Analyst"],
    officialUrl: "https://skillshop.withgoogle.com/"
  },
  {
    id: "meta-digital-marketing",
    name: "Meta Certified Digital Marketing Associate",
    provider: "Meta",
    category: "Marketing & Sales",
    level: "Associate",
    description: "Entry-level credential for Meta digital marketing.",
    skills: ["Meta Ads", "Social Media", "Digital Marketing"],
    careerPaths: ["Digital Marketer", "Social Media Specialist", "Marketing Assistant"],
    officialUrl: "https://www.facebook.com/business/learn/certification"
  },
  {
    id: "meta-media-buying",
    name: "Meta Certified Media Buying Professional",
    provider: "Meta",
    category: "Marketing & Sales",
    level: "Professional",
    description: "Professional credential for media buying on Meta.",
    skills: ["Meta Ads", "Media Buying", "Paid Social"],
    careerPaths: ["Media Buyer", "Performance Marketer", "Paid Social Specialist"],
    officialUrl: "https://www.facebook.com/business/learn/certification"
  },
  {
    id: "salesforce-associate",
    name: "Salesforce Certified Associate",
    provider: "Salesforce",
    category: "Marketing & Sales",
    level: "Foundation",
    description: "Foundational Salesforce and CRM credential.",
    skills: ["Salesforce", "CRM", "Business Processes"],
    careerPaths: ["CRM Specialist", "Salesforce Administrator", "Business Analyst"],
    officialUrl: "https://trailhead.salesforce.com/credentials"
  },
  {
    id: "salesforce-administrator",
    name: "Salesforce Administrator",
    provider: "Salesforce",
    category: "Marketing & Sales",
    level: "Professional",
    description: "Professional Salesforce administration credential.",
    skills: ["Salesforce", "CRM", "Administration"],
    careerPaths: ["Salesforce Administrator", "CRM Administrator", "Business Systems Analyst"],
    officialUrl: "https://trailhead.salesforce.com/credentials/administrator"
  },
  {
    id: "salesforce-sales-cloud",
    name: "Salesforce Sales Cloud Consultant",
    provider: "Salesforce",
    category: "Marketing & Sales",
    level: "Professional",
    description: "Professional credential for Salesforce Sales Cloud consulting.",
    skills: ["Salesforce", "Sales Cloud", "CRM"],
    careerPaths: ["CRM Consultant", "Salesforce Consultant", "Sales Operations Specialist"],
    officialUrl: "https://trailhead.salesforce.com/credentials"
  },

  // ============================================================
  // DESIGN & CREATIVE
  // ============================================================

  {
    id: "adobe-photoshop",
    name: "Adobe Certified Professional in Photoshop",
    provider: "Adobe",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential for Photoshop skills.",
    skills: ["Photoshop", "Image Editing", "Design"],
    careerPaths: ["Graphic Designer", "Photo Editor", "Creative Designer"],
    officialUrl: "https://certifiedprofessional.adobe.com/"
  },
  {
    id: "adobe-illustrator",
    name: "Adobe Certified Professional in Illustrator",
    provider: "Adobe",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential for Illustrator skills.",
    skills: ["Illustrator", "Vector Design", "Graphic Design"],
    careerPaths: ["Graphic Designer", "Illustrator", "Visual Designer"],
    officialUrl: "https://certifiedprofessional.adobe.com/"
  },
  {
    id: "adobe-indesign",
    name: "Adobe Certified Professional in InDesign",
    provider: "Adobe",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential for page-layout and publishing workflows.",
    skills: ["InDesign", "Layout", "Publishing"],
    careerPaths: ["Graphic Designer", "Layout Designer", "Production Designer"],
    officialUrl: "https://certifiedprofessional.adobe.com/"
  },
  {
    id: "adobe-premiere",
    name: "Adobe Certified Professional in Premiere Pro",
    provider: "Adobe",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential for video editing with Premiere Pro.",
    skills: ["Premiere Pro", "Video Editing", "Post Production"],
    careerPaths: ["Video Editor", "Content Creator", "Post Production Specialist"],
    officialUrl: "https://certifiedprofessional.adobe.com/"
  },
  {
    id: "adobe-after-effects",
    name: "Adobe Certified Professional in After Effects",
    provider: "Adobe",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential for motion graphics and visual effects.",
    skills: ["After Effects", "Motion Graphics", "Video"],
    careerPaths: ["Motion Designer", "VFX Artist", "Video Editor"],
    officialUrl: "https://certifiedprofessional.adobe.com/"
  },
  {
    id: "autodesk-maya-user",
    name: "Autodesk Certified User: Maya",
    provider: "Autodesk",
    category: "Design & Creative",
    level: "Foundation",
    description: "Foundational credential for 3D modeling and animation.",
    skills: ["Maya", "3D", "Animation"],
    careerPaths: ["3D Artist", "Animator", "3D Modeler"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "autodesk-3ds-max-user",
    name: "Autodesk Certified User: 3ds Max",
    provider: "Autodesk",
    category: "Design & Creative",
    level: "Foundation",
    description: "Foundational credential for 3D modeling and visualization.",
    skills: ["3ds Max", "3D", "Visualization"],
    careerPaths: ["3D Artist", "Architectural Visualizer", "3D Modeler"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "ux-usability",
    name: "Certified Usability Analyst",
    provider: "Human Factors International",
    category: "Design & Creative",
    level: "Professional",
    description: "Professional credential in usability and user research.",
    skills: ["UX Research", "Usability", "Human Factors"],
    careerPaths: ["UX Researcher", "Usability Analyst", "Product Designer"],
    officialUrl: "https://www.humanfactors.com/"
  },
  {
    id: "figma-design",
    name: "Figma Professional Design Credential",
    provider: "Figma",
    category: "Design & Creative",
    level: "Professional",
    description: "Credential focused on collaborative digital design workflows.",
    skills: ["Figma", "UI Design", "Prototyping"],
    careerPaths: ["UI Designer", "UX Designer", "Product Designer"],
    officialUrl: "https://help.figma.com/"
  },

  // ============================================================
  // MANUFACTURING & SUPPLY CHAIN
  // ============================================================

  {
    id: "ascm-cpim",
    name: "ASCM CPIM",
    provider: "ASCM",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Professional credential for production and inventory management.",
    skills: ["Supply Chain", "Inventory", "Planning"],
    careerPaths: ["Supply Chain Planner", "Production Planner", "Operations Manager"],
    officialUrl: "https://www.ascm.org/learning-development/certifications-credentials/cpim/"
  },
  {
    id: "ascm-cscp",
    name: "ASCM CSCP",
    provider: "ASCM",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Professional credential covering end-to-end supply chain management.",
    skills: ["Supply Chain", "Logistics", "Operations"],
    careerPaths: ["Supply Chain Manager", "Supply Chain Analyst", "Operations Manager"],
    officialUrl: "https://www.ascm.org/learning-development/certifications-credentials/cscp/"
  },
  {
    id: "ascm-cltd",
    name: "ASCM CLTD",
    provider: "ASCM",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Professional credential for logistics, transportation and distribution.",
    skills: ["Logistics", "Transportation", "Distribution"],
    careerPaths: ["Logistics Manager", "Distribution Manager", "Supply Chain Analyst"],
    officialUrl: "https://www.ascm.org/learning-development/certifications-credentials/cltd/"
  },
  {
    id: "cpsm",
    name: "Certified Professional in Supply Management",
    provider: "ISM",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Professional procurement and supply-management credential.",
    skills: ["Procurement", "Sourcing", "Supply Chain"],
    careerPaths: ["Procurement Manager", "Buyer", "Supply Chain Manager"],
    officialUrl: "https://www.ismworld.org/certification-and-training/certification/cpsm/"
  },
  {
    id: "lean-six-sigma-yellow",
    name: "Lean Six Sigma Yellow Belt",
    provider: "IASSC",
    category: "Manufacturing & Supply Chain",
    level: "Foundation",
    description: "Foundational process-improvement credential.",
    skills: ["Lean", "Six Sigma", "Process Improvement"],
    careerPaths: ["Process Analyst", "Quality Technician", "Operations Analyst"],
    officialUrl: "https://www.iassc.org/"
  },
  {
    id: "lean-six-sigma-green",
    name: "Lean Six Sigma Green Belt",
    provider: "IASSC",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Professional process-improvement credential.",
    skills: ["Lean", "Six Sigma", "DMAIC"],
    careerPaths: ["Process Engineer", "Continuous Improvement Engineer", "Quality Engineer"],
    officialUrl: "https://www.iassc.org/"
  },
  {
    id: "lean-six-sigma-black",
    name: "Lean Six Sigma Black Belt",
    provider: "IASSC",
    category: "Manufacturing & Supply Chain",
    level: "Professional",
    description: "Advanced improvement and change-leadership credential.",
    skills: ["Lean", "Six Sigma", "Leadership"],
    careerPaths: ["Continuous Improvement Manager", "Operations Manager", "Quality Manager"],
    officialUrl: "https://www.iassc.org/"
  },
  {
    id: "asq-quality-technician",
    name: "ASQ Certified Quality Technician",
    provider: "ASQ",
    category: "Manufacturing & Supply Chain",
    level: "Associate",
    description: "Technician-level quality credential.",
    skills: ["Quality", "Inspection", "Manufacturing"],
    careerPaths: ["Quality Technician", "QC Inspector", "Production Technician"],
    officialUrl: "https://www.asq.org/cert"
  },

  // ============================================================
  // ENERGY & ENVIRONMENT
  // ============================================================

  {
    id: "nebosh-igc",
    name: "NEBOSH International General Certificate",
    provider: "NEBOSH",
    category: "Energy & Environment",
    level: "Professional",
    description: "International occupational health and safety credential.",
    skills: ["Health & Safety", "Risk", "Compliance"],
    careerPaths: ["HSE Officer", "Safety Engineer", "HSE Manager"],
    officialUrl: "https://www.nebosh.org.uk/qualifications/international-general-certificate/"
  },
  {
    id: "nebosh-environmental",
    name: "NEBOSH Environmental Management Certificate",
    provider: "NEBOSH",
    category: "Energy & Environment",
    level: "Professional",
    description: "Environmental management and sustainability credential.",
    skills: ["Environment", "Sustainability", "Compliance"],
    careerPaths: ["Environmental Officer", "Sustainability Specialist", "HSE Manager"],
    officialUrl: "https://www.nebosh.org.uk/"
  },
  {
    id: "iso-14001-lead-auditor",
    name: "ISO 14001 Lead Auditor",
    provider: "ISO Training Providers",
    category: "Energy & Environment",
    level: "Professional",
    description: "Professional environmental management systems auditing credential.",
    skills: ["ISO 14001", "Environmental Management", "Auditing"],
    careerPaths: ["Environmental Auditor", "HSE Manager", "Sustainability Consultant"],
    officialUrl: "https://www.iso.org/iso-14001-environmental-management.html"
  },
  {
    id: "iso-45001-lead-auditor",
    name: "ISO 45001 Lead Auditor",
    provider: "ISO Training Providers",
    category: "Energy & Environment",
    level: "Professional",
    description: "Professional occupational health and safety auditing credential.",
    skills: ["ISO 45001", "Safety", "Auditing"],
    careerPaths: ["Safety Auditor", "HSE Manager", "Compliance Specialist"],
    officialUrl: "https://www.iso.org/iso-45001-occupational-health-and-safety.html"
  },
  {
    id: "certified-energy-manager",
    name: "Certified Energy Manager",
    provider: "AEE",
    category: "Energy & Environment",
    level: "Professional",
    description: "Professional credential in energy management and efficiency.",
    skills: ["Energy Management", "Efficiency", "Sustainability"],
    careerPaths: ["Energy Manager", "Energy Engineer", "Sustainability Manager"],
    officialUrl: "https://www.aeecenter.org/certified-energy-manager/"
  },
  {
    id: "leed-ap-om",
    name: "LEED AP Operations + Maintenance",
    provider: "USGBC",
    category: "Energy & Environment",
    level: "Professional",
    description: "Advanced credential for sustainable building operations.",
    skills: ["LEED", "Building Operations", "Sustainability"],
    careerPaths: ["Sustainability Manager", "Facilities Manager", "Energy Manager"],
    officialUrl: "https://www.usgbc.org/credentials"
  },
  {
    id: "well-ap",
    name: "WELL AP",
    provider: "IWBI",
    category: "Energy & Environment",
    level: "Professional",
    description: "Professional credential focused on health and wellness in buildings.",
    skills: ["WELL", "Healthy Buildings", "Sustainability"],
    careerPaths: ["Sustainability Consultant", "Building Consultant", "Facilities Manager"],
    officialUrl: "https://www.wellcertified.com/"
  },
  {
    id: "breeam-assessor",
    name: "BREEAM Assessor",
    provider: "BRE",
    category: "Energy & Environment",
    level: "Professional",
    description: "Professional credential for BREEAM sustainability assessment.",
    skills: ["BREEAM", "Sustainability", "Buildings"],
    careerPaths: ["Sustainability Consultant", "BREEAM Assessor", "Building Consultant"],
    officialUrl: "https://www.bregroup.com/breeam/"
  },

  // ============================================================
  // EDUCATION
  // ============================================================

  {
    id: "google-certified-educator-1",
    name: "Google Certified Educator Level 1",
    provider: "Google",
    category: "Education",
    level: "Foundation",
    description: "Foundational credential for educators using Google tools.",
    skills: ["Google Workspace", "Education Technology", "Teaching"],
    careerPaths: ["Teacher", "Education Technology Specialist", "Trainer"],
    officialUrl: "https://edu.google.com/intl/en_us/for-educators/"
  },
  {
    id: "google-certified-educator-2",
    name: "Google Certified Educator Level 2",
    provider: "Google",
    category: "Education",
    level: "Professional",
    description: "Advanced educator credential for Google education tools.",
    skills: ["Google Workspace", "EdTech", "Teaching"],
    careerPaths: ["Teacher", "Instructional Technology Specialist", "Trainer"],
    officialUrl: "https://edu.google.com/intl/en_us/for-educators/"
  },
  {
    id: "google-certified-trainer",
    name: "Google Certified Trainer",
    provider: "Google",
    category: "Education",
    level: "Professional",
    description: "Professional credential for training educators on Google tools.",
    skills: ["Google Workspace", "Training", "EdTech"],
    careerPaths: ["EdTech Trainer", "Instructional Coach", "Technology Trainer"],
    officialUrl: "https://edu.google.com/intl/en_us/for-educators/"
  },
  {
    id: "microsoft-certified-educator",
    name: "Microsoft Certified Educator",
    provider: "Microsoft",
    category: "Education",
    level: "Professional",
    description: "Credential for educators integrating technology into teaching.",
    skills: ["Microsoft", "Education Technology", "Teaching"],
    careerPaths: ["Teacher", "Instructional Technology Specialist", "Education Consultant"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "apple-teacher",
    name: "Apple Teacher",
    provider: "Apple",
    category: "Education",
    level: "Foundation",
    description: "Professional learning recognition for Apple education tools.",
    skills: ["Apple", "Education Technology", "Teaching"],
    careerPaths: ["Teacher", "EdTech Specialist", "Instructional Designer"],
    officialUrl: "https://education.apple.com/"
  },
  {
    id: "celta",
    name: "CELTA",
    provider: "Cambridge",
    category: "Education",
    level: "Professional",
    description: "International qualification for teaching English to speakers of other languages.",
    skills: ["English Teaching", "TESOL", "Lesson Planning"],
    careerPaths: ["English Teacher", "ESL Instructor", "Language Trainer"],
    officialUrl: "https://www.cambridgeenglish.org/teaching-english/teaching-qualifications/celta/"
  },
  {
    id: "delta",
    name: "DELTA",
    provider: "Cambridge",
    category: "Education",
    level: "Expert",
    description: "Advanced English language teaching qualification.",
    skills: ["English Teaching", "TESOL", "Teacher Development"],
    careerPaths: ["Senior English Teacher", "Teacher Trainer", "Academic Manager"],
    officialUrl: "https://www.cambridgeenglish.org/teaching-english/teaching-qualifications/delta/"
  },
  {
    id: "instructional-design",
    name: "Instructional Design Certificate",
    provider: "Multiple Providers",
    category: "Education",
    level: "Professional",
    description: "Professional learning pathway for instructional design.",
    skills: ["Instructional Design", "eLearning", "Learning"],
    careerPaths: ["Instructional Designer", "eLearning Developer", "Learning Specialist"],
    officialUrl: "https://www.td.org/"
  },

  // ============================================================
  // GENERAL BUSINESS / OFFICE
  // ============================================================

  {
    id: "mos-excel-associate",
    name: "Microsoft Office Specialist: Excel Associate",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Associate",
    description: "Validates practical Excel skills for business productivity.",
    skills: ["Excel", "Spreadsheets", "Data"],
    careerPaths: ["Administrative Assistant", "Data Analyst", "Office Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/mos-excel-2019/"
  },
  {
    id: "mos-excel-expert",
    name: "Microsoft Office Specialist: Excel Expert",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Expert",
    description: "Advanced Excel productivity credential.",
    skills: ["Excel", "Advanced Excel", "Data Analysis"],
    careerPaths: ["Financial Analyst", "Data Analyst", "Business Analyst"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/mos-excel-2019/"
  },
  {
    id: "mos-word",
    name: "Microsoft Office Specialist: Word Associate",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Associate",
    description: "Validates professional Word document skills.",
    skills: ["Word", "Documents", "Office Productivity"],
    careerPaths: ["Administrative Assistant", "Office Specialist", "Business Coordinator"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "mos-powerpoint",
    name: "Microsoft Office Specialist: PowerPoint Associate",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Associate",
    description: "Validates professional presentation skills.",
    skills: ["PowerPoint", "Presentations", "Office"],
    careerPaths: ["Business Analyst", "Executive Assistant", "Marketing Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "power-platform-fundamentals",
    name: "Microsoft Power Platform Fundamentals",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Foundational credential for low-code business solutions.",
    skills: ["Power Platform", "Low Code", "Business Applications"],
    careerPaths: ["Power Platform Analyst", "Business Analyst", "Automation Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/power-platform-fundamentals/"
  },
  {
    id: "power-platform-functional-consultant",
    name: "Microsoft Power Platform Functional Consultant Associate",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Associate",
    description: "Associate credential for Power Platform business solutions.",
    skills: ["Power Platform", "Power Apps", "Power Automate"],
    careerPaths: ["Power Platform Consultant", "Business Analyst", "Automation Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "dynamics-365-fundamentals",
    name: "Microsoft Dynamics 365 Fundamentals",
    provider: "Microsoft",
    category: "Project & Business Management",
    level: "Foundation",
    description: "Foundational credential for Dynamics 365 business applications.",
    skills: ["Dynamics 365", "CRM", "ERP"],
    careerPaths: ["Business Analyst", "CRM Specialist", "ERP Support Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },

  // ============================================================
  // ADDITIONAL IT / CLOUD / DEVELOPMENT
  // ============================================================

  {
    id: "cisco-devnet-associate",
    name: "Cisco DevNet Associate",
    provider: "Cisco",
    category: "IT & Networking",
    level: "Associate",
    description: "Associate credential for network automation and software development.",
    skills: ["Cisco", "Python", "Network Automation"],
    careerPaths: ["Network Automation Engineer", "DevNet Engineer", "Network Engineer"],
    officialUrl: "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/devnet/index.html"
  },
  {
    id: "cisco-cyberops-associate",
    name: "Cisco CyberOps Associate",
    provider: "Cisco",
    category: "Cybersecurity",
    level: "Associate",
    description: "Associate credential for security operations.",
    skills: ["Cisco", "SOC", "Cybersecurity"],
    careerPaths: ["SOC Analyst", "Cybersecurity Analyst", "Security Operations Specialist"],
    officialUrl: "https://www.cisco.com/site/us/en/learn/training-certifications/certifications/cyberops/index.html"
  },
  {
    id: "oracle-oci-foundations",
    name: "Oracle Cloud Infrastructure Foundations",
    provider: "Oracle",
    category: "Cloud & DevOps",
    level: "Foundation",
    description: "Foundational Oracle Cloud Infrastructure credential.",
    skills: ["Oracle Cloud", "Cloud Fundamentals", "Infrastructure"],
    careerPaths: ["Cloud Support Associate", "OCI Administrator", "Cloud Analyst"],
    officialUrl: "https://education.oracle.com/oracle-cloud-infrastructure-foundations"
  },
  {
    id: "oracle-oci-architect-associate",
    name: "Oracle Cloud Infrastructure Architect Associate",
    provider: "Oracle",
    category: "Cloud & DevOps",
    level: "Associate",
    description: "Associate credential for Oracle Cloud architecture.",
    skills: ["OCI", "Cloud Architecture", "Infrastructure"],
    careerPaths: ["Cloud Architect", "OCI Engineer", "Solutions Architect"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "oracle-oci-developer",
    name: "Oracle Cloud Infrastructure Developer Professional",
    provider: "Oracle",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional OCI development credential.",
    skills: ["OCI", "Development", "Cloud"],
    careerPaths: ["Cloud Developer", "Software Engineer", "OCI Developer"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "oracle-oci-networking",
    name: "Oracle Cloud Infrastructure Networking Professional",
    provider: "Oracle",
    category: "Cloud & DevOps",
    level: "Professional",
    description: "Professional OCI networking credential.",
    skills: ["OCI", "Networking", "Cloud"],
    careerPaths: ["Cloud Network Engineer", "Network Engineer", "Cloud Architect"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "oracle-oci-security",
    name: "Oracle Cloud Infrastructure Security Professional",
    provider: "Oracle",
    category: "Cybersecurity",
    level: "Professional",
    description: "Professional OCI security credential.",
    skills: ["OCI", "Cloud Security", "IAM"],
    careerPaths: ["Cloud Security Engineer", "Security Architect", "OCI Security Engineer"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
    id: "salesforce-platform-app-builder",
    name: "Salesforce Platform App Builder",
    provider: "Salesforce",
    category: "Software & Programming",
    level: "Professional",
    description: "Professional credential for Salesforce low-code application development.",
    skills: ["Salesforce", "Low Code", "CRM"],
    careerPaths: ["Salesforce Developer", "CRM Consultant", "Business Analyst"],
    officialUrl: "https://trailhead.salesforce.com/credentials"
  },
  {
    id: "salesforce-platform-developer",
    name: "Salesforce Platform Developer I",
    provider: "Salesforce",
    category: "Software & Programming",
    level: "Professional",
    description: "Professional credential for Salesforce development.",
    skills: ["Salesforce", "Apex", "Development"],
    careerPaths: ["Salesforce Developer", "CRM Developer", "Software Developer"],
    officialUrl: "https://trailhead.salesforce.com/credentials/platformdeveloperi"
  },
  {
    id: "kubernetes-ckad",
    name: "Certified Kubernetes Application Developer",
    provider: "CNCF",
    category: "Software & Programming",
    level: "Professional",
    description: "Professional credential for Kubernetes application development.",
    skills: ["Kubernetes", "Containers", "Application Development"],
    careerPaths: ["Cloud Developer", "DevOps Engineer", "Kubernetes Developer"],
    officialUrl: "https://training.linuxfoundation.org/certification/certified-kubernetes-application-developer-ckad/"
  },
  {
    id: "kubernetes-cks",
    name: "Certified Kubernetes Security Specialist",
    provider: "CNCF",
    category: "Cybersecurity",
    level: "Professional",
    description: "Advanced credential for Kubernetes security.",
    skills: ["Kubernetes", "Security", "Containers"],
    careerPaths: ["Cloud Security Engineer", "Kubernetes Security Engineer", "DevSecOps Engineer"],
    officialUrl: "https://training.linuxfoundation.org/certification/certified-kubernetes-security-specialist/"
  },
  {
    id: "microsoft-github-copilot",
    name: "GitHub Copilot",
    provider: "GitHub",
    category: "AI & Machine Learning",
    level: "Foundation",
    description: "Credential focused on using GitHub Copilot for AI-assisted development.",
    skills: ["GitHub Copilot", "AI", "Software Development"],
    careerPaths: ["Software Developer", "AI-Assisted Developer", "Developer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "microsoft-ai-fundamentals",
    name: "Microsoft Azure AI Fundamentals",
    provider: "Microsoft",
    category: "AI & Machine Learning",
    level: "Foundation",
    description: "Foundational credential covering AI concepts and Azure AI services.",
    skills: ["Azure AI", "AI Fundamentals", "Machine Learning"],
    careerPaths: ["AI Analyst", "AI Support Specialist", "Junior AI Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-fundamentals/"
  },
  {
    id: "microsoft-data-fundamentals",
    name: "Microsoft Azure Data Fundamentals",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Foundation",
    description: "Foundational credential covering core data concepts.",
    skills: ["Azure", "Data", "Databases"],
    careerPaths: ["Data Analyst", "Data Support Specialist", "Junior Data Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/azure-data-fundamentals/"
  },
  {
    id: "microsoft-security-fundamentals",
    name: "Microsoft Security, Compliance and Identity Fundamentals",
    provider: "Microsoft",
    category: "Cybersecurity",
    level: "Foundation",
    description: "Foundational credential covering security, compliance and identity concepts.",
    skills: ["Security", "Compliance", "Identity"],
    careerPaths: ["Security Analyst", "Compliance Analyst", "IT Security Specialist"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },

  // ============================================================
  // FINAL ENTRIES
  // ============================================================

  {
    id: "aws-machine-learning-specialty",
    name: "AWS Certified Machine Learning - Specialty",
    provider: "AWS",
    category: "AI & Machine Learning",
    level: "Specialty",
    description: "Specialty credential for machine learning on AWS.",
    skills: ["AWS", "Machine Learning", "AI"],
    careerPaths: ["ML Engineer", "Data Scientist", "AI Engineer"],
    officialUrl: "https://aws.amazon.com/certification/"
  },
  {
    id: "google-cloud-database-engineer",
    name: "Google Professional Cloud Database Engineer",
    provider: "Google Cloud",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional credential for database engineering on Google Cloud.",
    skills: ["Google Cloud", "Databases", "Cloud"],
    careerPaths: ["Cloud Database Engineer", "Database Engineer", "Cloud Engineer"],
    officialUrl: "https://cloud.google.com/learn/certification"
  },
  {
    id: "microsoft-power-bi",
    name: "Microsoft Power BI Data Analyst",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Associate",
    description: "Professional credential for data analysis using Power BI.",
    skills: ["Power BI", "Data Analysis", "DAX"],
    careerPaths: ["Data Analyst", "BI Analyst", "Power BI Developer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/certifications/data-analyst-associate/"
  },
  {
    id: "microsoft-fabric-analytics",
    name: "Microsoft Fabric Analytics Engineer Associate",
    provider: "Microsoft",
    category: "Data & Analytics",
    level: "Associate",
    description: "Associate credential for analytics engineering in Microsoft Fabric.",
    skills: ["Microsoft Fabric", "Analytics", "Data Engineering"],
    careerPaths: ["Analytics Engineer", "Data Engineer", "BI Engineer"],
    officialUrl: "https://learn.microsoft.com/en-us/credentials/"
  },
  {
    id: "oracle-database-professional",
    name: "Oracle Database Professional",
    provider: "Oracle",
    category: "Data & Analytics",
    level: "Professional",
    description: "Professional credential for Oracle database technologies.",
    skills: ["Oracle Database", "SQL", "Administration"],
    careerPaths: ["Database Administrator", "Database Engineer", "SQL Developer"],
    officialUrl: "https://education.oracle.com/certification"
  },
  {
  "id": "multiple-providers-educational-technology-certificate",
  "name": "Educational Technology Certificate",
  "provider": "Multiple Providers",
  "category": "Education",
  "level": "Professional",
  "description": "Professional credential validating skills relevant to education.",
  "skills": ["Teacher", "Trainer", "Instructional Designer"],
  "careerPaths": ["Teacher", "Trainer", "Instructional Designer"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/"
},
{
  "id": "aws-sysops-associate",
  "name": "AWS Certified CloudOps Engineer – Associate",
  "provider": "AWS",
  "category": "Cloud & DevOps",
  "level": "Associate",
  "description": "Validate operational skills for deploying, managing and monitoring workloads on AWS.",
  "skills": ["AWS", "Cloud operations", "Monitoring", "Networking", "Security"],
  "careerPaths": ["Cloud Engineer", "Cloud Operations Engineer", "DevOps Engineer"],
  "officialUrl": "https://aws.amazon.com/certification/certified-cloudops-engineer-associate/"
},
{
  "id": "aws-machine-learning-engineer-associate",
  "name": "AWS Certified Machine Learning Engineer – Associate",
  "provider": "AWS",
  "category": "AI & Machine Learning",
  "level": "Associate",
  "description": "Validate skills for implementing machine learning workloads in production on AWS.",
  "skills": ["AWS", "Machine Learning", "MLOps", "SageMaker", "Data"],
  "careerPaths": ["ML Engineer", "Machine Learning Engineer", "AI Engineer"],
  "officialUrl": "https://aws.amazon.com/certification/certified-machine-learning-engineer-associate/"
},
{
  "id": "google-cloud-developer",
  "name": "Professional Cloud Developer",
  "provider": "Google Cloud",
  "category": "Cloud & DevOps",
  "level": "Professional",
  "description": "Validate skills for building scalable, highly available applications using Google Cloud services.",
  "skills": ["Google Cloud", "Application development", "APIs", "Cloud native", "CI/CD"],
  "careerPaths": ["Cloud Developer", "Software Engineer", "Cloud Engineer"],
  "officialUrl": "https://cloud.google.com/learn/certification/cloud-developer"
},
{
  "id": "google-cloud-security-engineer",
  "name": "Professional Cloud Security Engineer",
  "provider": "Google Cloud",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate skills for designing and implementing secure workloads and infrastructure on Google Cloud.",
  "skills": ["Google Cloud", "Cloud security", "IAM", "Compliance", "Threat management"],
  "careerPaths": ["Cloud Security Engineer", "Security Engineer", "Cybersecurity Architect"],
  "officialUrl": "https://cloud.google.com/learn/certification/cloud-security-engineer"
},
{
  "id": "google-ml-engineer",
  "name": "Professional Machine Learning Engineer",
  "provider": "Google Cloud",
  "category": "AI & Machine Learning",
  "level": "Professional",
  "description": "Validate skills for building, productionizing and optimizing machine learning systems on Google Cloud.",
  "skills": ["Machine Learning", "Google Cloud", "MLOps", "AI", "Model deployment"],
  "careerPaths": ["ML Engineer", "AI Engineer", "Data Scientist"],
  "officialUrl": "https://cloud.google.com/learn/certification/machine-learning-engineer"
},
{
  "id": "microsoft-azure-developer-associate",
  "name": "Microsoft Certified: Azure Developer Associate",
  "provider": "Microsoft",
  "category": "Cloud & DevOps",
  "level": "Associate",
  "description": "Validate skills for designing, building, testing and maintaining cloud applications and services on Azure.",
  "skills": ["Azure", "Application development", "APIs", "Storage", "Security"],
  "careerPaths": ["Azure Developer", "Cloud Developer", "Software Engineer"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/azure-developer/"
},
{
  "id": "microsoft-azure-data-engineer",
  "name": "Microsoft Certified: Fabric Data Engineer Associate",
  "provider": "Microsoft",
  "category": "Data & Analytics",
  "level": "Associate",
  "description": "Validate skills for implementing data engineering solutions with Microsoft Fabric.",
  "skills": ["Microsoft Fabric", "Data engineering", "ETL", "Data pipelines", "SQL"],
  "careerPaths": ["Data Engineer", "Analytics Engineer", "BI Engineer"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/fabric-data-engineer-associate/"
},
{
  "id": "microsoft-power-bi-data-analyst",
  "name": "Microsoft Certified: Power BI Data Analyst Associate",
  "provider": "Microsoft",
  "category": "Data & Analytics",
  "level": "Associate",
  "description": "Validate skills for modeling, visualizing and analyzing data with Power BI.",
  "skills": ["Power BI", "Data analysis", "DAX", "Data modeling", "Visualization"],
  "careerPaths": ["Data Analyst", "BI Analyst", "Business Analyst"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/data-analyst-associate/"
},
{
  "id": "microsoft-azure-ai-engineer",
  "name": "Microsoft Certified: Azure AI Engineer Associate",
  "provider": "Microsoft",
  "category": "AI & Machine Learning",
  "level": "Associate",
  "description": "Validate skills for designing and implementing AI solutions using Azure AI services.",
  "skills": ["Azure AI", "Machine Learning", "Generative AI", "NLP", "Computer vision"],
  "careerPaths": ["AI Engineer", "ML Engineer", "Cloud AI Engineer"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-engineer/"
},
{
  "id": "microsoft-cybersecurity-architect",
  "name": "Microsoft Certified: Cybersecurity Architect Expert",
  "provider": "Microsoft",
  "category": "Cybersecurity",
  "level": "Expert",
  "description": "Validate advanced skills for designing cybersecurity strategies and architectures across Microsoft environments.",
  "skills": ["Cybersecurity", "Security architecture", "Zero Trust", "Cloud security", "Governance"],
  "careerPaths": ["Cybersecurity Architect", "Security Architect", "Security Engineer"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/cybersecurity-architect-expert/"
},
{
  "id": "comptia-data-plus",
  "name": "CompTIA Data+",
  "provider": "CompTIA",
  "category": "Data & Analytics",
  "level": "Professional",
  "description": "Validate foundational skills in data mining, analysis, visualization and governance.",
  "skills": ["Data analysis", "Data visualization", "Statistics", "Data governance"],
  "careerPaths": ["Data Analyst", "Business Analyst", "Reporting Analyst"],
  "officialUrl": "https://www.comptia.org/certifications/data"
},
{
  "id": "isc2-ccsp",
  "name": "CCSP – Certified Cloud Security Professional",
  "provider": "ISC2",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate cloud security architecture, operations, governance and risk skills.",
  "skills": ["Cloud security", "Cybersecurity", "IAM", "Risk", "Compliance"],
  "careerPaths": ["Cloud Security Engineer", "Cloud Security Architect", "Security Consultant"],
  "officialUrl": "https://www.isc2.org/certifications/ccsp"
},
{
  "id": "isc2-sscp",
  "name": "SSCP – Systems Security Certified Practitioner",
  "provider": "ISC2",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate hands-on skills for implementing and administering secure IT infrastructure.",
  "skills": ["Security operations", "Network security", "Access control", "Incident response"],
  "careerPaths": ["Security Administrator", "Security Analyst", "Systems Administrator"],
  "officialUrl": "https://www.isc2.org/certifications/sscp"
},
{
  "id": "databricks-data-engineer-associate",
  "name": "Databricks Certified Data Engineer Associate",
  "provider": "Databricks",
  "category": "Data & Analytics",
  "level": "Associate",
  "description": "Validate practical skills for building data pipelines and working with Databricks data platforms.",
  "skills": ["Databricks", "Spark", "SQL", "ETL", "Data pipelines"],
  "careerPaths": ["Data Engineer", "Analytics Engineer", "Data Platform Engineer"],
  "officialUrl": "https://www.databricks.com/learn/certification"
},
{
  "id": "tableau-certified-data-analyst",
  "name": "Tableau Certified Data Analyst",
  "provider": "Tableau",
  "category": "Data & Analytics",
  "level": "Professional",
  "description": "Validate practical data preparation, analysis and visualization skills in Tableau.",
  "skills": ["Tableau", "Data analysis", "Visualization", "Dashboards", "Analytics"],
  "careerPaths": ["Data Analyst", "BI Analyst", "Data Visualization Specialist"],
  "officialUrl": "https://www.tableau.com/learn/certification"
},
{
  "id": "ibm-ai-engineering-professional",
  "name": "IBM AI Engineering Professional Certificate",
  "provider": "IBM",
  "category": "AI & Machine Learning",
  "level": "Professional",
  "description": "Build practical skills in machine learning, deep learning and AI engineering.",
  "skills": ["AI", "Machine Learning", "Deep Learning", "Python", "TensorFlow"],
  "careerPaths": ["AI Engineer", "ML Engineer", "Data Scientist"],
  "officialUrl": "https://www.coursera.org/professional-certificates/ai-engineer"
},
{
  "id": "pmi-pmi-acp",
  "name": "PMI Agile Certified Practitioner (PMI-ACP)",
  "provider": "PMI",
  "category": "Project & Business Management",
  "level": "Professional",
  "description": "Validate practical knowledge of Agile principles, practices and delivery approaches.",
  "skills": ["Agile", "Scrum", "Kanban", "Project management"],
  "careerPaths": ["Project Manager", "Agile Project Manager", "Scrum Master"],
  "officialUrl": "https://www.pmi.org/certifications/agile-acp"
},
{
  "id": "pmi-pmi-rmp",
  "name": "PMI Risk Management Professional (PMI-RMP)",
  "provider": "PMI",
  "category": "Project & Business Management",
  "level": "Professional",
  "description": "Validate advanced project risk management knowledge and practice.",
  "skills": ["Risk management", "Project management", "Risk analysis", "Governance"],
  "careerPaths": ["Project Manager", "Risk Manager", "Project Risk Specialist"],
  "officialUrl": "https://www.pmi.org/certifications/risk-management-rmp"
},
{
  "id": "pmi-pmi-sp",
  "name": "PMI Scheduling Professional (PMI-SP)",
  "provider": "PMI",
  "category": "Project & Business Management",
  "level": "Professional",
  "description": "Validate specialized project scheduling knowledge and skills.",
  "skills": ["Project scheduling", "Planning", "Scheduling", "Project controls"],
  "careerPaths": ["Project Planner", "Planning Engineer", "Project Controls Specialist"],
  "officialUrl": "https://www.pmi.org/certifications/scheduling-sp"
},
{
  "id": "pmi-construction-professional",
  "name": "PMI Construction Professional (PMI-CP)",
  "provider": "PMI",
  "category": "Engineering",
  "level": "Professional",
  "description": "Validate construction project management and delivery skills.",
  "skills": ["Construction management", "Project management", "Contracts", "Safety"],
  "careerPaths": ["Construction Manager", "Project Manager", "Construction Engineer"],
  "officialUrl": "https://www.pmi.org/certifications/construction-cp"
},
{
  "id": "leed-ap-building-design",
  "name": "LEED AP Building Design + Construction",
  "provider": "USGBC",
  "category": "Engineering",
  "level": "Professional",
  "description": "Validate advanced knowledge of sustainable building design and construction.",
  "skills": ["LEED", "Sustainability", "Building design", "Green building"],
  "careerPaths": ["Architect", "BIM Engineer", "Sustainability Consultant", "Civil Engineer"],
  "officialUrl": "https://www.usgbc.org/credentials/leed-ap"
},
{
  "id": "cfa-level-i",
  "name": "CFA Program – Level I",
  "provider": "CFA Institute",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Build foundational investment analysis, ethics and portfolio management knowledge.",
  "skills": ["Investment analysis", "Finance", "Portfolio management", "Economics"],
  "careerPaths": ["Financial Analyst", "Investment Analyst", "Portfolio Analyst"],
  "officialUrl": "https://www.cfainstitute.org/programs/cfa-program"
},
{
  "id": "cfa-investment-foundations",
  "name": "CFA Investment Foundations Certificate",
  "provider": "CFA Institute",
  "category": "Finance & Accounting",
  "level": "Foundation",
  "description": "Build foundational knowledge of investment industry concepts and practices.",
  "skills": ["Finance", "Investments", "Ethics", "Markets"],
  "careerPaths": ["Finance Analyst", "Investment Operations Specialist", "Banking Professional"],
  "officialUrl": "https://www.cfainstitute.org/programs/investment-foundations-certificate"
},
{
  "id": "garp-frm",
  "name": "Financial Risk Manager (FRM)",
  "provider": "GARP",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Validate advanced knowledge of financial risk management.",
  "skills": ["Risk management", "Financial markets", "Quantitative analysis", "Risk modeling"],
  "careerPaths": ["Risk Analyst", "Risk Manager", "Financial Analyst"],
  "officialUrl": "https://www.garp.org/frm"
},
{
  "id": "ima-cma",
  "name": "Certified Management Accountant (CMA)",
  "provider": "IMA",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Validate expertise in management accounting, financial planning and strategic finance.",
  "skills": ["Management accounting", "Financial analysis", "FP&A", "Strategy"],
  "careerPaths": ["Management Accountant", "Financial Analyst", "FP&A Analyst"],
  "officialUrl": "https://www.imanet.org/cma-certification"
},
{
  "id": "iia-cia",
  "name": "Certified Internal Auditor (CIA)",
  "provider": "The IIA",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Validate professional internal auditing knowledge and practice.",
  "skills": ["Internal audit", "Risk", "Controls", "Governance"],
  "careerPaths": ["Internal Auditor", "Audit Manager", "Risk Analyst"],
  "officialUrl": "https://www.theiia.org/en/certifications/cia/"
},
{
  "id": "aicpa-cpa",
  "name": "Certified Public Accountant (CPA)",
  "provider": "AICPA",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Professional accounting credential covering financial reporting, audit, tax and related practice.",
  "skills": ["Accounting", "Audit", "Tax", "Financial reporting"],
  "careerPaths": ["Accountant", "Auditor", "Tax Consultant", "Finance Manager"],
  "officialUrl": "https://www.aicpa-cima.com/"
},
{
  "id": "acca-qualification",
  "name": "ACCA Qualification",
  "provider": "ACCA",
  "category": "Finance & Accounting",
  "level": "Professional",
  "description": "Global professional accounting qualification covering accounting, audit, tax and finance.",
  "skills": ["Accounting", "Audit", "Tax", "Financial management"],
  "careerPaths": ["Accountant", "Auditor", "Financial Analyst", "Finance Manager"],
  "officialUrl": "https://www.accaglobal.com/"
},
{
  "id": "hrci-phr",
  "name": "Professional in Human Resources (PHR)",
  "provider": "HRCI",
  "category": "HR",
  "level": "Professional",
  "description": "Validate professional-level HR knowledge in employee and operational HR practice.",
  "skills": ["HR operations", "Employment law", "Employee relations", "Compensation"],
  "careerPaths": ["HR Specialist", "HR Generalist", "HR Manager"],
  "officialUrl": "https://www.hrci.org/certifications/individual-certifications/phr"
},
{
  "id": "hrci-sphr",
  "name": "Senior Professional in Human Resources (SPHR)",
  "provider": "HRCI",
  "category": "HR",
  "level": "Senior Professional",
  "description": "Validate strategic and senior-level HR knowledge and leadership.",
  "skills": ["HR strategy", "Leadership", "Employment law", "Workforce planning"],
  "careerPaths": ["HR Director", "HR Business Partner", "Head of HR"],
  "officialUrl": "https://www.hrci.org/certifications/individual-certifications/sphr"
},
{
  "id": "ahima-chda",
  "name": "Certified Health Data Analyst (CHDA)",
  "provider": "AHIMA",
  "category": "Healthcare",
  "level": "Professional",
  "description": "Validate healthcare data analysis, interpretation, reporting and governance skills.",
  "skills": ["Healthcare analytics", "Data analysis", "Reporting", "Data governance"],
  "careerPaths": ["Healthcare Data Analyst", "Clinical Data Analyst", "Health Informatics Specialist"],
  "officialUrl": "https://www.ahima.org/certification-careers/certifications-overview/chda/"
},
{
  "id": "aapc-cpc",
  "name": "Certified Professional Coder (CPC)",
  "provider": "AAPC",
  "category": "Healthcare",
  "level": "Professional",
  "description": "Validate professional medical coding knowledge across clinical documentation and coding systems.",
  "skills": ["Medical coding", "Healthcare billing", "ICD-10-CM", "CPT"],
  "careerPaths": ["Medical Coder", "Coding Specialist", "Revenue Cycle Specialist"],
  "officialUrl": "https://www.aapc.com/certifications/cpc/"
},
{
  "id": "aapc-cpb",
  "name": "Certified Professional Biller (CPB)",
  "provider": "AAPC",
  "category": "Healthcare",
  "level": "Professional",
  "description": "Validate medical billing knowledge for healthcare revenue cycle processes.",
  "skills": ["Medical billing", "Claims", "Revenue cycle", "Healthcare administration"],
  "careerPaths": ["Medical Biller", "Revenue Cycle Specialist", "Billing Coordinator"],
  "officialUrl": "https://www.aapc.com/certifications/cpb/"
},
{
  "id": "hubspot-sales-software",
  "name": "HubSpot Sales Software Certification",
  "provider": "HubSpot",
  "category": "Marketing & Sales",
  "level": "Professional",
  "description": "Validate practical use of HubSpot sales tools, pipelines and reporting.",
  "skills": ["CRM", "Sales operations", "Pipeline management", "Reporting"],
  "careerPaths": ["Sales Operations Specialist", "Sales Representative", "CRM Specialist"],
  "officialUrl": "https://academy.hubspot.com/courses/hubspot-sales-software"
},
{
  "id": "google-ads-certification",
  "name": "Google Ads Certification",
  "provider": "Google",
  "category": "Marketing & Sales",
  "level": "Professional",
  "description": "Validate practical knowledge of Google Ads campaign strategy, measurement and optimization.",
  "skills": ["Google Ads", "Paid search", "Campaign management", "Analytics"],
  "careerPaths": ["Digital Marketing Specialist", "PPC Specialist", "Performance Marketer"],
  "officialUrl": "https://skillshop.withgoogle.com/"
},
{
  "id": "google-analytics-certification",
  "name": "Google Analytics Certification",
  "provider": "Google",
  "category": "Marketing & Sales",
  "level": "Professional",
  "description": "Validate skills for using Google Analytics to measure and interpret digital performance.",
  "skills": ["Google Analytics", "Web analytics", "Measurement", "Reporting"],
  "careerPaths": ["Digital Analyst", "Marketing Analyst", "Web Analyst"],
  "officialUrl": "https://skillshop.withgoogle.com/"
},
{
  "id": "iapp-cipp-us",
  "name": "Certified Information Privacy Professional/United States (CIPP/US)",
  "provider": "IAPP",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate knowledge of U.S. privacy laws, regulations and privacy program requirements.",
  "skills": ["Privacy", "Data protection", "U.S. privacy law", "Compliance"],
  "careerPaths": ["Privacy Specialist", "Privacy Analyst", "Compliance Manager"],
  "officialUrl": "https://iapp.org/train/certification/cipp-us/"
},
{
  "id": "iapp-cipp-e",
  "name": "Certified Information Privacy Professional/Europe (CIPP/E)",
  "provider": "IAPP",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate knowledge of European privacy laws and GDPR requirements.",
  "skills": ["Privacy", "GDPR", "Data protection", "Compliance"],
  "careerPaths": ["Privacy Specialist", "Privacy Counsel", "Compliance Analyst"],
  "officialUrl": "https://iapp.org/train/certification/cipp-e/"
},
{
  "id": "iapp-cipm",
  "name": "Certified Information Privacy Manager (CIPM)",
  "provider": "IAPP",
  "category": "Cybersecurity",
  "level": "Professional",
  "description": "Validate skills for designing and operating privacy programs and governance processes.",
  "skills": ["Privacy management", "Governance", "Compliance", "Risk"],
  "careerPaths": ["Privacy Manager", "Data Protection Officer", "Privacy Program Manager"],
  "officialUrl": "https://iapp.org/train/certification/cipm/"
},
{
  "id": "redhat-rhcsa",
  "name": "Red Hat Certified System Administrator (RHCSA)",
  "provider": "Red Hat",
  "category": "IT & Networking",
  "level": "Professional",
  "description": "Validate core Linux system administration skills on Red Hat Enterprise Linux.",
  "skills": ["Linux", "System administration", "Security", "Storage", "Networking"],
  "careerPaths": ["Linux Administrator", "System Administrator", "DevOps Engineer"],
  "officialUrl": "https://www.redhat.com/en/services/certification/rhcsa"
},
{
  "id": "redhat-rhce",
  "name": "Red Hat Certified Engineer (RHCE)",
  "provider": "Red Hat",
  "category": "Cloud & DevOps",
  "level": "Professional",
  "description": "Validate advanced Linux automation and system administration skills using Ansible.",
  "skills": ["Linux", "Ansible", "Automation", "System administration"],
  "careerPaths": ["Linux Engineer", "DevOps Engineer", "Automation Engineer"],
  "officialUrl": "https://www.redhat.com/en/services/certification/rhce"
},
{
  "id": "google-certified-educator",
  "name": "Google Certified Educator",
  "provider": "Google for Education",
  "category": "Education",
  "level": "Professional",
  "description": "Validate effective use of Google tools and technology to support teaching and learning.",
  "skills": ["Google Workspace", "Teaching", "Digital learning", "Technology integration"],
  "careerPaths": ["Teacher", "Educator", "Instructional Technology Specialist"],
  "officialUrl": "https://edu.google.com/teacher-center/certifications/"
},
{
  "id": "microsoft-mos-excel",
  "name": "Microsoft Office Specialist: Excel Associate",
  "provider": "Microsoft",
  "category": "Project & Business Management",
  "level": "Associate",
  "description": "Validate practical Excel skills for worksheets, formulas, tables, charts and data management.",
  "skills": ["Excel", "Spreadsheets", "Data analysis", "Reporting"],
  "careerPaths": ["Data Analyst", "Business Analyst", "Office Professional", "Finance Analyst"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/mos-excel-associate-m365-apps/"
},
{
  "id": "microsoft-mos-excel-expert",
  "name": "Microsoft Office Specialist: Excel Expert",
  "provider": "Microsoft",
  "category": "Project & Business Management",
  "level": "Expert",
  "description": "Validate advanced Excel skills for complex workbooks, formulas, data analysis and automation.",
  "skills": ["Excel", "Advanced formulas", "Data analysis", "Automation"],
  "careerPaths": ["Financial Analyst", "Data Analyst", "Business Analyst", "FP&A Analyst"],
  "officialUrl": "https://learn.microsoft.com/en-us/credentials/certifications/mos-excel-expert-m365-apps/"
},
{
  "id": "peoplecert-itil-foundation",
  "name": "ITIL 4 Foundation",
  "provider": "PeopleCert",
  "category": "IT & Networking",
  "level": "Foundation",
  "description": "Build foundational knowledge of modern IT service management and ITIL practices.",
  "skills": ["IT service management", "ITIL", "Service desk", "Processes"],
  "careerPaths": ["IT Service Manager", "Service Desk Analyst", "IT Support Specialist"],
  "officialUrl": "https://www.peoplecert.org/certifications/itil-certifications/itil-foundation/"
}
];


// ============================================================
// FREE LEARNING
// ============================================================

export const FREE_LEARNING = [
  {
    id: "autodesk-revit-cert-prep",
    name: "Autodesk Revit Certification Prep",
    provider: "Autodesk",
    category: "Architecture, BIM & Construction",
    description: "Learning resources for preparing for Autodesk Revit certification.",
    skills: ["Revit", "BIM"],
    officialUrl: "https://www.autodesk.com/certification"
  },
  {
    id: "cisco-networking-academy",
    name: "Cisco Networking Academy",
    provider: "Cisco",
    category: "IT & Networking",
    description: "Networking and technology learning resources.",
    skills: ["Networking", "Cybersecurity", "IT"],
    officialUrl: "https://www.netacad.com/"
  },
  {
    id: "aws-skill-builder",
    name: "AWS Skill Builder",
    provider: "AWS",
    category: "Cloud & DevOps",
    description: "AWS learning resources and certification preparation.",
    skills: ["AWS", "Cloud", "DevOps"],
    officialUrl: "https://skillbuilder.aws/"
  },
  {
    id: "microsoft-learn",
    name: "Microsoft Learn",
    provider: "Microsoft",
    category: "Software & Programming",
    description: "Free Microsoft learning paths and certification preparation.",
    skills: ["Microsoft", "Azure", "Development"],
    officialUrl: "https://learn.microsoft.com/"
  },
  {
    id: "google-cloud-skills",
    name: "Google Cloud Skills Boost",
    provider: "Google Cloud",
    category: "Cloud & DevOps",
    description: "Hands-on Google Cloud learning and labs.",
    skills: ["Google Cloud", "Cloud", "DevOps"],
    officialUrl: "https://www.cloudskillsboost.google/"
  },
  {
    id: "hubspot-academy",
    name: "HubSpot Academy",
    provider: "HubSpot",
    category: "Marketing & Sales",
    description: "Free courses and certifications in marketing, sales and CRM.",
    skills: ["Marketing", "Sales", "CRM"],
    officialUrl: "https://academy.hubspot.com/"
  }
];
